msgid ""
msgstr ""
"POT-Creation-Date: 2025-05-03 21:08+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/components/account-block.jsx:198
msgid "Locked"
msgstr ""

#. placeholder {0}: shortenNumber(statusesCount)
#: src/components/account-block.jsx:205
msgid "Posts: {0}"
msgstr ""

#: src/components/account-block.jsx:211
msgid "Last active: {date}"
msgstr "Last active: {date}"

#: src/components/account-block.jsx:229
#: src/components/account-info.jsx:730
msgid "Automated"
msgstr ""

#: src/components/account-block.jsx:237
#: src/components/account-info.jsx:736
#: src/components/status.jsx:616
msgctxt "account type"
msgid "Group"
msgstr "Group"

#: src/components/account-block.jsx:247
msgid "Mutual"
msgstr ""

#: src/components/account-block.jsx:251
#: src/components/related-actions.jsx:991
msgid "Requested"
msgstr ""

#: src/components/account-block.jsx:255
#: src/components/related-actions.jsx:982
msgctxt "follow state"
msgid "Following"
msgstr "Following"

#: src/components/account-block.jsx:259
#: src/components/related-actions.jsx:211
msgid "Follows you"
msgstr ""

#. placeholder {0}: shortenNumber(followersCount)
#. placeholder {1}: shortenNumber(followersCount)
#: src/components/account-block.jsx:287
msgid "{followersCount, plural, one {<0>{0}</0> follower} other {<1>{1}</1> followers}}"
msgstr "{followersCount, plural, one {<0>{0}</0> follower} other {<1>{1}</1> followers}}"

#: src/components/account-block.jsx:312
#: src/components/account-info.jsx:779
msgid "Verified"
msgstr ""

#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#. placeholder {0}: niceDateTime(createdAt, { hideTime: true, })
#: src/components/account-block.jsx:328
#: src/components/account-info.jsx:918
msgid "Joined <0>{0}</0>"
msgstr ""

#: src/components/account-handle-info.jsx:18
msgid "username"
msgstr ""

#: src/components/account-handle-info.jsx:22
msgid "server domain name"
msgstr ""

#: src/components/account-info-mini.jsx:57
#: src/components/account-info.jsx:801
#: src/components/compose.jsx:2075
#: src/pages/settings.jsx:308
#: src/utils/visibility-text.jsx:7
msgid "Followers"
msgstr "Followers"

#: src/components/account-info-mini.jsx:61
#: src/components/account-info-mini.jsx:100
#: src/components/account-info.jsx:808
#: src/components/account-info.jsx:866
msgid "This user has chosen to not make this information available."
msgstr "This user has chosen to not make this information available."

#. placeholder {0}: shortenNumber(followersCount)
#. placeholder {1}: shortenNumber(followersCount)
#: src/components/account-info-mini.jsx:67
#: src/components/account-info.jsx:828
msgid "{followersCount, plural, one {<0>{0}</0> Follower} other {<1>{1}</1> Followers}}"
msgstr "{followersCount, plural, one {<0>{0}</0> Follower} other {<1>{1}</1> Followers}}"

#: src/components/account-info-mini.jsx:93
#: src/components/account-info.jsx:856
msgctxt "followed accounts"
msgid "Following"
msgstr "Following"

#. placeholder {0}: shortenNumber(followingCount)
#: src/components/account-info-mini.jsx:106
#: src/components/account-info.jsx:872
msgid "{followingCount, plural, other {<0>{0}</0> Following}}"
msgstr "{followingCount, plural, other {<0>{0}</0> Following}}"

#. placeholder {0}: shortenNumber(statusesCount)
#. placeholder {1}: shortenNumber(statusesCount)
#: src/components/account-info-mini.jsx:119
#: src/components/account-info.jsx:896
msgid "{statusesCount, plural, one {<0>{0}</0> Post} other {<1>{1}</1> Posts}}"
msgstr "{statusesCount, plural, one {<0>{0}</0> Post} other {<1>{1}</1> Posts}}"

#: src/components/account-info.jsx:119
msgid "View profile"
msgstr "View profile"

#: src/components/account-info.jsx:388
msgid "Unable to load account."
msgstr "Unable to load account."

#: src/components/account-info.jsx:403
msgid "Go to account page"
msgstr "Go to account page"

#. Infinitive form
#. Infinitive form
#. Infinitive form
#. Infinitive form
#. Infinitive form
#. Infinitive form
#. Infinitive form
#: src/components/account-info.jsx:409
#: src/components/timeline.jsx:666
#: src/components/timeline2.jsx:702
#: src/pages/home.jsx:237
#: src/pages/notifications.jsx:1076
#: src/pages/status.jsx:1270
#: src/pages/status.jsx:1746
msgid "Try again"
msgstr ""

#: src/components/account-info.jsx:463
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> has indicated that their new account is now:"

#: src/components/account-info.jsx:619
#: src/components/related-actions.jsx:544
msgid "Handle copied"
msgstr "Handle copied"

#: src/components/account-info.jsx:622
#: src/components/related-actions.jsx:547
msgid "Unable to copy handle"
msgstr "Unable to copy handle"

#: src/components/account-info.jsx:628
#: src/components/related-actions.jsx:553
msgid "Copy handle"
msgstr ""

#: src/components/account-info.jsx:646
#: src/components/related-actions.jsx:621
#: src/components/related-actions.jsx:896
#: src/components/shortcuts-settings.jsx:1099
msgid "QR code"
msgstr "QR code"

#: src/components/account-info.jsx:652
msgid "Go to original profile page"
msgstr ""

#: src/components/account-info.jsx:671
msgid "View profile image"
msgstr "View profile image"

#: src/components/account-info.jsx:690
msgid "View profile header"
msgstr "View profile header"

#: src/components/account-info.jsx:706
#: src/components/edit-profile-sheet.jsx:267
#: src/components/related-actions.jsx:910
msgid "Edit profile"
msgstr ""

#: src/components/account-info.jsx:725
msgid "In Memoriam"
msgstr ""

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.quotes / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {3}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:953
msgid "{0} original posts, {1} replies, {2} quotes, {3} boosts"
msgstr "{0} original posts, {1} replies, {2} quotes, {3} boosts"

#. placeholder {0}: ( postingStats.originals / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {1}: ( postingStats.replies / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#. placeholder {2}: ( postingStats.boosts / postingStats.total ).toLocaleString(i18n.locale || undefined, { style: 'percent', })
#: src/components/account-info.jsx:970
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} original posts, {1} replies, {2} boosts"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.daysSinceLastPost
#. placeholder {2}: postingStats.daysSinceLastPost
#. placeholder {3}: postingStats.daysSinceLastPost
#. placeholder {4}: postingStats.total
#. placeholder {5}: postingStats.total
#. placeholder {6}: postingStats.daysSinceLastPost
#: src/components/account-info.jsx:987
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"

#. placeholder {0}: postingStats.total
#. placeholder {1}: postingStats.total
#: src/components/account-info.jsx:1003
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"

#: src/components/account-info.jsx:1061
#: src/pages/catchup.jsx:74
#: src/pages/year-in-posts.jsx:1392
msgid "Original"
msgstr ""

#: src/components/account-info.jsx:1065
#: src/components/status.jsx:2838
#: src/pages/account-statuses.jsx:428
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1597
#: src/pages/catchup.jsx:2252
#: src/pages/status.jsx:1216
#: src/pages/status.jsx:1946
#: src/pages/year-in-posts.jsx:1396
msgid "Replies"
msgstr ""

#: src/components/account-info.jsx:1070
#: src/components/quotes-modal.jsx:81
#: src/components/status.jsx:2843
#: src/pages/catchup.jsx:76
#: src/pages/catchup.jsx:1600
#: src/pages/year-in-posts.jsx:1402
msgid "Quotes"
msgstr "Quotes"

#: src/components/account-info.jsx:1075
#: src/pages/account-statuses.jsx:444
#: src/pages/catchup.jsx:77
#: src/pages/catchup.jsx:1599
#: src/pages/catchup.jsx:2264
#: src/pages/settings.jsx:1337
#: src/pages/year-in-posts.jsx:1408
msgid "Boosts"
msgstr ""

#: src/components/account-info.jsx:1081
msgid "Post stats unavailable."
msgstr "Post stats unavailable."

#: src/components/account-info.jsx:1108
msgid "View post stats"
msgstr "View post stats"

#: src/components/account-sheet.jsx:38
#: src/components/add-remove-lists-sheet.jsx:45
#: src/components/collection-add-account.jsx:133
#: src/components/collection-add-edit.jsx:40
#: src/components/collection-manage-accounts.jsx:111
#: src/components/compose.jsx:1147
#: src/components/custom-emojis-modal.jsx:282
#: src/components/drafts.jsx:57
#: src/components/edit-profile-sheet.jsx:262
#: src/components/embed-modal.jsx:13
#: src/components/generic-accounts.jsx:151
#: src/components/gif-picker-modal.jsx:71
#: src/components/import-accounts-selection.jsx:81
#: src/components/import-export-accounts.jsx:108
#: src/components/keyboard-shortcuts-help.jsx:53
#: src/components/list-add-edit.jsx:37
#: src/components/media-alt-modal.jsx:43
#: src/components/media-attachment.jsx:420
#: src/components/media-modal.jsx:362
#: src/components/mention-modal.jsx:162
#: src/components/notification-service.jsx:152
#: src/components/open-link-sheet.jsx:51
#: src/components/post-embed-modal.jsx:197
#: src/components/private-note-sheet.jsx:36
#: src/components/qr-code-modal.jsx:33
#: src/components/qr-scanner-modal.jsx:257
#: src/components/quote-chain-modal.jsx:102
#: src/components/quote-settings-sheet.jsx:61
#: src/components/quotes-modal.jsx:76
#: src/components/report-collection.jsx:33
#: src/components/report-modal.jsx:118
#: src/components/shortcuts-settings.jsx:247
#: src/components/shortcuts-settings.jsx:600
#: src/components/shortcuts-settings.jsx:801
#: src/components/status.jsx:3508
#: src/components/status.jsx:3720
#: src/components/translated-bio-sheet.jsx:21
#: src/pages/accounts.jsx:48
#: src/pages/catchup.jsx:1734
#: src/pages/filters.jsx:225
#: src/pages/list.jsx:302
#: src/pages/notifications.jsx:1120
#: src/pages/scheduled-posts.jsx:288
#: src/pages/settings.jsx:100
#: src/pages/status.jsx:1684
msgid "Close"
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:50
#: src/components/related-actions.jsx:484
#: src/components/related-actions.jsx:494
msgid "Add/Remove from Lists"
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:90
msgid "Unable to remove from list."
msgstr "Unable to remove from list."

#: src/components/add-remove-lists-sheet.jsx:91
msgid "Unable to add to list."
msgstr "Unable to add to list."

#: src/components/add-remove-lists-sheet.jsx:110
#: src/pages/lists.jsx:131
msgid "Unable to load lists."
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:114
msgid "No lists."
msgstr ""

#: src/components/add-remove-lists-sheet.jsx:125
#: src/components/list-add-edit.jsx:41
#: src/pages/lists.jsx:62
msgid "New list"
msgstr ""

#: src/components/background-service.jsx:211
msgid "Cloak mode disabled"
msgstr ""

#: src/components/background-service.jsx:211
msgid "Cloak mode enabled"
msgstr ""

#. More from [Author]
#: src/components/byline.jsx:16
msgid "More from <0/>"
msgstr "More from <0/>"

#: src/components/collection-account-actions.jsx:35
#: src/pages/collection.jsx:426
msgid "Remove me from this collection?"
msgstr "Remove me from this collection?"

#: src/components/collection-account-actions.jsx:44
#: src/pages/collection.jsx:435
msgid "The curator won't be able to re-add you to this collection for 24 hours. Block them to prevent them from adding you to any collections."
msgstr "The curator won't be able to re-add you to this collection for 24 hours. Block them to prevent them from adding you to any collections."

#: src/components/collection-account-actions.jsx:69
#: src/pages/collection.jsx:446
msgid "Remove me…"
msgstr "Remove me…"

#: src/components/collection-account-actions.jsx:107
#: src/components/related-actions.jsx:1001
#: src/components/related-actions.jsx:1005
#: src/pages/hashtag.jsx:294
msgid "Follow"
msgstr ""

#: src/components/collection-add-account.jsx:92
msgid "@{username} added to collection"
msgstr "@{username} added to collection"

#: src/components/collection-add-account.jsx:96
msgid "Unable to add account"
msgstr "Unable to add account"

#: src/components/collection-add-account.jsx:148
#: src/components/mention-modal.jsx:179
msgid "Search accounts"
msgstr "Search accounts"

#: src/components/collection-add-account.jsx:197
#: src/components/compose-poll.jsx:80
#: src/components/compose.jsx:1798
#: src/components/mention-modal.jsx:221
#: src/components/shortcuts-settings.jsx:732
#: src/pages/list.jsx:388
msgid "Add"
msgstr ""

#: src/components/collection-add-account.jsx:220
#: src/components/generic-accounts.jsx:236
#: src/components/mention-modal.jsx:234
msgid "Error loading accounts"
msgstr ""

#: src/components/collection-add-account.jsx:231
msgid "These accounts may have opted out of discovery or be on a server that doesn't support collections."
msgstr "These accounts may have opted out of discovery or be on a server that doesn't support collections."

#: src/components/collection-add-account.jsx:236
msgid "These accounts review all follow requests. Followers can add them to collections."
msgstr "These accounts review all follow requests. Followers can add them to collections."

#: src/components/collection-add-edit.jsx:45
#: src/pages/account-collections.jsx:181
msgid "New collection"
msgstr "New collection"

#: src/components/collection-add-edit.jsx:45
msgid "Edit collection"
msgstr "Edit collection"

#: src/components/collection-add-edit.jsx:97
msgid "Unable to update collection."
msgstr "Unable to update collection."

#: src/components/collection-add-edit.jsx:98
msgid "Unable to create collection."
msgstr "Unable to create collection."

#: src/components/collection-add-edit.jsx:106
#: src/components/edit-profile-sheet.jsx:574
#: src/components/list-add-edit.jsx:106
msgctxt "label"
msgid "Name"
msgstr "Name"

#: src/components/collection-add-edit.jsx:124
msgid "Description"
msgstr "Description"

#: src/components/collection-add-edit.jsx:146
msgid "Language"
msgstr "Language"

#: src/components/collection-add-edit.jsx:169
msgid "Mark as sensitive"
msgstr "Mark as sensitive"

#: src/components/collection-add-edit.jsx:183
#: src/components/compose.jsx:2063
#: src/pages/collection.jsx:690
#: src/pages/settings.jsx:302
#: src/utils/visibility-text.jsx:4
msgid "Public"
msgstr ""

#: src/components/collection-add-edit.jsx:186
#: src/components/collection-card.jsx:201
#: src/pages/collection.jsx:684
msgid "Unlisted"
msgstr "Unlisted"

#: src/components/collection-add-edit.jsx:192
#: src/components/edit-profile-sheet.jsx:695
#: src/components/list-add-edit.jsx:152
#: src/components/quote-settings-sheet.jsx:92
#: src/components/shortcuts-settings.jsx:732
#: src/pages/filters.jsx:572
#: src/pages/notifications.jsx:1192
msgid "Save"
msgstr ""

#: src/components/collection-add-edit.jsx:192
#: src/components/list-add-edit.jsx:152
#: src/pages/filters.jsx:572
msgid "Create"
msgstr ""

#: src/components/collection-add-edit.jsx:199
msgid "Delete this collection?"
msgstr "Delete this collection?"

#: src/components/collection-add-edit.jsx:215
msgid "Unable to delete collection."
msgstr "Unable to delete collection."

#: src/components/collection-add-edit.jsx:225
#: src/components/drafts.jsx:126
#: src/components/edit-profile-sheet.jsx:108
#: src/components/edit-profile-sheet.jsx:120
#: src/components/list-add-edit.jsx:188
#: src/components/status.jsx:1692
#: src/pages/filters.jsx:605
#: src/pages/scheduled-posts.jsx:398
msgid "Delete…"
msgstr ""

#: src/components/collection-card.jsx:178
msgid "Collection by <0>@{username}</0>"
msgstr "Collection by <0>@{username}</0>"

#: src/components/collection-card.jsx:189
#: src/pages/collection.jsx:672
msgid "Last updated: <relativeTime/>"
msgstr "Last updated: <relativeTime/>"

#: src/components/collection-manage-accounts.jsx:89
msgid "@{username} removed from collection"
msgstr "@{username} removed from collection"

#: src/components/collection-manage-accounts.jsx:93
msgid "Unable to remove account"
msgstr "Unable to remove account"

#: src/components/collection-manage-accounts.jsx:115
#: src/pages/collection.jsx:409
msgid "Manage accounts"
msgstr "Manage accounts"

#: src/components/collection-manage-accounts.jsx:134
msgid "Pending"
msgstr "Pending"

#: src/components/collection-manage-accounts.jsx:141
msgid "Remove <0>{username}</0> from this collection?"
msgstr "Remove <0>{username}</0> from this collection?"

#: src/components/collection-manage-accounts.jsx:161
#: src/components/edit-profile-sheet.jsx:473
#: src/components/edit-profile-sheet.jsx:565
#: src/pages/list.jsx:388
msgid "Remove…"
msgstr ""

#: src/components/collection-manage-accounts.jsx:175
#: src/pages/collection.jsx:650
msgid "Add account"
msgstr "Add account"

#: src/components/columns.jsx:29
#: src/components/nav-menu.jsx:188
#: src/components/shortcuts-settings.jsx:142
#: src/components/timeline.jsx:549
#: src/components/timeline2.jsx:581
#: src/pages/account-collections.jsx:142
#: src/pages/catchup.jsx:1030
#: src/pages/filters.jsx:90
#: src/pages/followed-hashtags.jsx:41
#: src/pages/home.jsx:55
#: src/pages/home.jsx:63
#: src/pages/notifications.jsx:749
#: src/pages/scheduled-posts.jsx:74
msgid "Home"
msgstr ""

#: src/components/compose-button.jsx:154
#: src/compose.jsx:43
msgid "Compose"
msgstr ""

#: src/components/compose-button.jsx:181
#: src/components/nav-menu.jsx:280
#: src/pages/scheduled-posts.jsx:31
#: src/pages/scheduled-posts.jsx:78
msgid "Scheduled Posts"
msgstr "Scheduled Posts"

#: src/components/compose-button.jsx:194
msgid "Add to thread"
msgstr "Add to thread"

#. placeholder {0}: i + 1
#: src/components/compose-poll.jsx:43
msgid "Choice {0}"
msgstr "Choice {0}"

#: src/components/compose-poll.jsx:64
#: src/components/media-attachment.jsx:384
#: src/components/shortcuts-settings.jsx:743
#: src/pages/catchup.jsx:1231
#: src/pages/filters.jsx:415
msgid "Remove"
msgstr ""

#: src/components/compose-poll.jsx:96
msgid "Multiple choice"
msgstr "Multiple choice"

#: src/components/compose-poll.jsx:99
msgid "Duration"
msgstr ""

#: src/components/compose-poll.jsx:129
msgid "Remove poll"
msgstr ""

#: src/components/compose.jsx:124
msgid "Take photo or video"
msgstr "Take photo or video"

#: src/components/compose.jsx:125
#: src/components/compose.jsx:1891
msgid "Add media"
msgstr "Add media"

#: src/components/compose.jsx:126
msgid "Add custom emoji"
msgstr ""

#: src/components/compose.jsx:127
msgid "Add GIF"
msgstr "Add GIF"

#: src/components/compose.jsx:128
msgid "Add poll"
msgstr ""

#: src/components/compose.jsx:129
msgid "Add content warning"
msgstr "Add content warning"

#: src/components/compose.jsx:130
msgid "Schedule post"
msgstr "Schedule post"

#. placeholder {0}: unsupportedFiles.length
#. placeholder {1}: unsupportedFiles[0].name
#. placeholder {2}: lf.format( unsupportedFiles.map((f) => f.name), )
#: src/components/compose.jsx:280
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"

#: src/components/compose.jsx:296
#: src/components/compose.jsx:2209
#: src/components/file-picker-input.jsx:56
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr ""

#: src/components/compose.jsx:653
msgid "You have unsaved changes. Discard this post?"
msgstr "You have unsaved changes. Discard this post?"

#: src/components/compose.jsx:1127
msgid "Pop out"
msgstr "Pop out"

#: src/components/compose.jsx:1135
msgid "Minimize"
msgstr "Minimize"

#: src/components/compose.jsx:1171
msgid "Looks like you closed the parent window."
msgstr "Looks like you closed the parent window."

#: src/components/compose.jsx:1178
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."

#: src/components/compose.jsx:1183
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"

#: src/components/compose.jsx:1229
msgid "Pop in"
msgstr "Pop in"

#. placeholder {0}: replyToStatus.account.acct ? punycode.toUnicode(replyToStatus.account.acct) : replyToStatus.account.username
#. placeholder {1}: rtf.format(-replyToStatusMonthsAgo, 'month')
#: src/components/compose.jsx:1239
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr ""

#. placeholder {0}: replyToStatus.account.acct ? punycode.toUnicode(replyToStatus.account.acct) : replyToStatus.account.username
#: src/components/compose.jsx:1251
msgid "Replying to @{0}’s post"
msgstr ""

#: src/components/compose.jsx:1266
msgid "Editing source post"
msgstr ""

#: src/components/compose.jsx:1335
msgid "Poll must have at least 2 options"
msgstr "Poll must have at least 2 options"

#: src/components/compose.jsx:1339
msgid "Some poll choices are empty"
msgstr "Some poll choices are empty"

#: src/components/compose.jsx:1352
msgid "Some media have no descriptions. Continue?"
msgstr "Some media have no descriptions. Continue?"

#: src/components/compose.jsx:1409
msgid "Attachment #{i} failed"
msgstr "Attachment #{i} failed"

#: src/components/compose.jsx:1538
#: src/components/status.jsx:2570
#: src/components/timeline.jsx:1065
msgid "Content warning"
msgstr ""

#: src/components/compose.jsx:1570
#: src/components/compose.jsx:1716
#: src/components/edit-profile-sheet.jsx:692
#: src/components/import-accounts-selection.jsx:175
#: src/components/open-link-sheet.jsx:74
#: src/components/private-note-sheet.jsx:92
#: src/components/quote-suggestion.jsx:35
msgid "Cancel"
msgstr ""

#: src/components/compose.jsx:1578
msgid "Post your reply"
msgstr "Post your reply"

#: src/components/compose.jsx:1580
msgid "Edit your post"
msgstr "Edit your post"

#: src/components/compose.jsx:1582
msgid "Ask a question"
msgstr "Ask a question"

#: src/components/compose.jsx:1583
msgid "What are you doing?"
msgstr "What are you doing?"

#: src/components/compose.jsx:1656
msgid "Mark media as sensitive"
msgstr ""

#: src/components/compose.jsx:1696
msgid "Posting on <0/>"
msgstr "Posting on <0/>"

#: src/components/compose.jsx:1995
#: src/components/quote-settings-sheet.jsx:82
#: src/components/status.jsx:303
#: src/pages/settings.jsx:350
msgid "Anyone can quote"
msgstr "Anyone can quote"

#: src/components/compose.jsx:1998
#: src/components/quote-settings-sheet.jsx:85
#: src/components/status.jsx:304
#: src/pages/settings.jsx:353
msgid "Your followers can quote"
msgstr "Your followers can quote"

#: src/components/compose.jsx:2001
#: src/components/quote-settings-sheet.jsx:88
#: src/components/status.jsx:305
#: src/pages/settings.jsx:356
msgid "Only you can quote"
msgstr "Only you can quote"

#: src/components/compose.jsx:2041
msgid "Quotes can't be embedded in private mentions."
msgstr "Quotes can't be embedded in private mentions."

#: src/components/compose.jsx:2068
#: src/components/nav-menu.jsx:367
#: src/components/shortcuts-settings.jsx:168
#: src/utils/visibility-text.jsx:5
msgid "Local"
msgstr ""

#: src/components/compose.jsx:2072
#: src/pages/settings.jsx:305
#: src/utils/visibility-text.jsx:6
msgid "Quiet public"
msgstr "Quiet public"

#: src/components/compose.jsx:2078
#: src/components/status.jsx:2449
#: src/utils/visibility-text.jsx:8
msgid "Private mention"
msgstr ""

#: src/components/compose.jsx:2134
msgid "Schedule"
msgstr "Schedule"

#: src/components/compose.jsx:2136
#: src/components/keyboard-shortcuts-help.jsx:165
#: src/components/status.jsx:1113
#: src/components/status.jsx:1162
#: src/components/status.jsx:2201
#: src/components/status.jsx:2202
#: src/components/status.jsx:2970
#: src/components/status.jsx:2982
msgid "Reply"
msgstr ""

#: src/components/compose.jsx:2138
msgid "Update"
msgstr "Update"

#: src/components/compose.jsx:2139
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Post"

#: src/components/compose.jsx:2221
msgid "Downloading GIF…"
msgstr "Downloading GIF…"

#: src/components/compose.jsx:2245
msgid "Failed to download GIF"
msgstr "Failed to download GIF"

#. placeholder {0}: NF(i18n.locale).format(emojis.length - max)
#: src/components/custom-emojis-modal.jsx:106
msgid "{0} more…"
msgstr ""

#: src/components/custom-emojis-modal.jsx:288
msgid "Custom emojis"
msgstr ""

#: src/components/custom-emojis-modal.jsx:333
msgid "Search emoji"
msgstr "Search emoji"

#: src/components/custom-emojis-modal.jsx:366
msgid "Error loading custom emojis"
msgstr ""

#: src/components/custom-emojis-modal.jsx:377
msgid "Recently used"
msgstr "Recently used"

#: src/components/custom-emojis-modal.jsx:378
msgid "Others"
msgstr "Others"

#: src/components/custom-emojis-modal.jsx:397
msgid "Zoom out"
msgstr "Zoom out"

#: src/components/custom-emojis-modal.jsx:405
msgid "Zoom in"
msgstr "Zoom in"

#: src/components/custom-emojis-modal.jsx:412
msgid "Custom emojis are not available on this server."
msgstr "Custom emojis are not available on this server."

#: src/components/drafts.jsx:62
#: src/pages/settings.jsx:782
msgid "Unsent drafts"
msgstr ""

#: src/components/drafts.jsx:67
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr ""

#: src/components/drafts.jsx:101
msgid "Delete this draft?"
msgstr ""

#: src/components/drafts.jsx:116
msgid "Error deleting draft! Please try again."
msgstr ""

#: src/components/drafts.jsx:147
msgid "Error fetching reply-to status!"
msgstr ""

#: src/components/drafts.jsx:159
msgid "Error fetching quoted status!"
msgstr "Error fetching quoted status!"

#: src/components/drafts.jsx:187
msgid "Delete all drafts?"
msgstr ""

#: src/components/drafts.jsx:205
msgid "Error deleting drafts! Please try again."
msgstr ""

#: src/components/drafts.jsx:217
msgid "Delete all…"
msgstr ""

#: src/components/drafts.jsx:225
msgid "No drafts found."
msgstr ""

#: src/components/drafts.jsx:276
#: src/pages/catchup.jsx:2111
msgid "Poll"
msgstr ""

#: src/components/drafts.jsx:279
#: src/pages/account-statuses.jsx:462
msgid "Media"
msgstr ""

#: src/components/drafts.jsx:283
#: src/components/keyboard-shortcuts-help.jsx:194
#: src/components/status.jsx:774
msgid "Quote"
msgstr ""

#: src/components/edit-history-controls.jsx:21
msgid "Edit History Snapshots"
msgstr "Edit History Snapshots"

#: src/components/edit-history-controls.jsx:35
#: src/components/gif-picker-modal.jsx:208
#: src/components/media-modal.jsx:504
#: src/components/timeline.jsx:978
msgid "Previous"
msgstr ""

#: src/components/edit-history-controls.jsx:47
#: src/components/gif-picker-modal.jsx:226
#: src/components/media-modal.jsx:523
#: src/components/timeline.jsx:995
msgid "Next"
msgstr ""

#: src/components/edit-history-controls.jsx:57
msgid "Exit"
msgstr "Exit"

#: src/components/edit-profile-sheet.jsx:87
#: src/components/media-alt-modal.jsx:55
#: src/components/media-attachment.jsx:465
#: src/components/media-modal.jsx:398
#: src/components/related-actions.jsx:267
#: src/components/status.jsx:2226
#: src/components/status.jsx:2243
#: src/components/status.jsx:2375
#: src/components/status.jsx:3141
#: src/components/status.jsx:3144
#: src/pages/account-statuses.jsx:676
#: src/pages/accounts.jsx:155
#: src/pages/collection.jsx:288
#: src/pages/hashtag.jsx:232
#: src/pages/list.jsx:171
#: src/pages/public.jsx:147
#: src/pages/scheduled-posts.jsx:89
#: src/pages/status.jsx:1585
#: src/pages/trending.jsx:474
msgid "More"
msgstr ""

#: src/components/edit-profile-sheet.jsx:94
#: src/components/shortcuts-settings.jsx:368
#: src/pages/accounts.jsx:225
msgid "Move up"
msgstr ""

#: src/components/edit-profile-sheet.jsx:100
#: src/components/shortcuts-settings.jsx:384
#: src/pages/accounts.jsx:240
msgid "Move down"
msgstr ""

#: src/components/edit-profile-sheet.jsx:115
msgid "Delete this field?"
msgstr "Delete this field?"

#: src/components/edit-profile-sheet.jsx:225
msgid "Unable to remove profile picture."
msgstr "Unable to remove profile picture."

#: src/components/edit-profile-sheet.jsx:245
msgid "Unable to remove header picture."
msgstr "Unable to remove header picture."

#: src/components/edit-profile-sheet.jsx:296
msgid "Profile and header pictures have no descriptions. Continue?"
msgstr "Profile and header pictures have no descriptions. Continue?"

#: src/components/edit-profile-sheet.jsx:303
msgid "Profile picture has no description. Continue?"
msgstr "Profile picture has no description. Continue?"

#: src/components/edit-profile-sheet.jsx:309
msgid "Header picture has no description. Continue?"
msgstr "Header picture has no description. Continue?"

#: src/components/edit-profile-sheet.jsx:371
msgid "Unable to update profile."
msgstr "Unable to update profile."

#: src/components/edit-profile-sheet.jsx:389
msgid "Header picture"
msgstr "Header picture"

#: src/components/edit-profile-sheet.jsx:444
#: src/components/edit-profile-sheet.jsx:536
#: src/components/media-attachment.jsx:242
msgid "Image description"
msgstr "Image description"

#: src/components/edit-profile-sheet.jsx:462
msgid "Remove header picture?"
msgstr "Remove header picture?"

#: src/components/edit-profile-sheet.jsx:481
msgid "Profile picture"
msgstr "Profile picture"

#: src/components/edit-profile-sheet.jsx:554
msgid "Remove profile picture?"
msgstr "Remove profile picture?"

#: src/components/edit-profile-sheet.jsx:590
msgid "Bio"
msgstr ""

#: src/components/edit-profile-sheet.jsx:607
msgid "Custom fields"
msgstr "Custom fields"

#: src/components/edit-profile-sheet.jsx:613
msgid "Label"
msgstr ""

#: src/components/edit-profile-sheet.jsx:616
msgid "Content"
msgstr ""

#: src/components/edit-profile-sheet.jsx:678
msgid "Add field"
msgstr "Add field"

#: src/components/embed-modal.jsx:18
msgid "Open in new window"
msgstr ""

#. placeholder {0}: info.username
#: src/components/endorsements.jsx:72
msgid "Profiles featured by @{0}"
msgstr "Profiles featured by @{0}"

#: src/components/endorsements.jsx:98
msgid "No featured profiles."
msgstr "No featured profiles."

#: src/components/follow-request-buttons.jsx:45
#: src/pages/notifications.jsx:1176
msgid "Accept"
msgstr ""

#: src/components/follow-request-buttons.jsx:72
msgid "Reject"
msgstr ""

#: src/components/follow-request-buttons.jsx:79
#: src/pages/notifications.jsx:1462
msgid "Accepted"
msgstr ""

#: src/components/follow-request-buttons.jsx:83
msgid "Rejected"
msgstr ""

#: src/components/generic-accounts.jsx:154
#: src/components/notification.jsx:502
#: src/pages/accounts.jsx:53
#: src/pages/search.jsx:125
#: src/pages/search.jsx:465
msgid "Accounts"
msgstr ""

#: src/components/generic-accounts.jsx:214
#: src/components/quotes-modal.jsx:129
#: src/components/timeline.jsx:631
#: src/pages/account-collections.jsx:234
#: src/pages/list.jsx:321
#: src/pages/notifications.jsx:1100
#: src/pages/search.jsx:553
#: src/pages/status.jsx:1717
msgid "Show more…"
msgstr ""

#: src/components/generic-accounts.jsx:219
#: src/components/quote-chain-modal.jsx:169
#: src/components/quotes-modal.jsx:133
#: src/components/timeline.jsx:636
#: src/components/timeline2.jsx:680
#: src/pages/search.jsx:558
msgid "The end."
msgstr ""

#: src/components/generic-accounts.jsx:240
msgid "Nothing to show"
msgstr ""

#: src/components/gif-picker-modal.jsx:86
msgid "Search GIFs"
msgstr "Search GIFs"

#: src/components/gif-picker-modal.jsx:102
msgid "Powered by GIPHY"
msgstr "Powered by GIPHY"

#: src/components/gif-picker-modal.jsx:110
msgid "Type to search GIFs"
msgstr ""

#: src/components/gif-picker-modal.jsx:243
msgid "Error loading GIFs"
msgstr ""

#: src/components/import-accounts-selection.jsx:86
msgid "Select accounts to import"
msgstr "Select accounts to import"

#: src/components/import-accounts-selection.jsx:117
msgid "Select all"
msgstr "Select all"

#: src/components/import-accounts-selection.jsx:158
msgid "Existing"
msgstr "Existing"

#: src/components/import-accounts-selection.jsx:183
msgid "{selectedCount, plural, one {Import # account} other {Import # accounts}}"
msgstr "{selectedCount, plural, one {Import # account} other {Import # accounts}}"

#: src/components/import-export-accounts.jsx:52
msgid "Export failed"
msgstr "Export failed"

#: src/components/import-export-accounts.jsx:72
msgid "Import failed"
msgstr "Import failed"

#: src/components/import-export-accounts.jsx:113
msgid "Import/Export <0>Accounts</0>"
msgstr "Import/Export <0>Accounts</0>"

#: src/components/import-export-accounts.jsx:128
#: src/components/shortcuts-settings.jsx:816
msgid "Import"
msgstr ""

#: src/components/import-export-accounts.jsx:139
msgid "Select file…"
msgstr "Select file…"

#: src/components/import-export-accounts.jsx:151
#: src/components/shortcuts-settings.jsx:1066
msgid "Export"
msgstr ""

#. placeholder {0}: accounts.length
#. placeholder {0}: sortedItems.length
#: src/components/import-export-accounts.jsx:155
#: src/pages/collection.jsx:663
msgid "{0, plural, one {# account} other {# accounts}}"
msgstr "{0, plural, one {# account} other {# accounts}}"

#: src/components/import-export-accounts.jsx:167
msgid "No login information or account access details are stored in the exported files. You will need to log in again for each account after importing."
msgstr "No login information or account access details are stored in the exported files. You will need to log in again for each account after importing."

#: src/components/keyboard-shortcuts-help.jsx:16
msgid "<0>{key1}</0> then <1>{key2}</1>"
msgstr "<0>{key1}</0> then <1>{key2}</1>"

#: src/components/keyboard-shortcuts-help.jsx:57
#: src/components/nav-menu.jsx:389
#: src/pages/catchup.jsx:1772
msgid "Keyboard shortcuts"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "Keyboard shortcuts help"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:69
#: src/pages/catchup.jsx:1797
msgid "Next post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:73
#: src/pages/catchup.jsx:1805
msgid "Previous post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:77
msgid "Skip carousel to next post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "<0>Shift</0> + <1>j</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "Skip carousel to previous post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:87
msgid "<0>Shift</0> + <1>k</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:93
msgid "Load new posts"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:97
#: src/pages/catchup.jsx:1829
msgid "Open post details"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Open media or post details"
msgstr "Open media or post details"

#: src/components/keyboard-shortcuts-help.jsx:106
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:115
msgid "Close post or dialogs"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:123
msgid "Focus column in multi-column mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:125
msgid "<0>1</0> to <1>9</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:131
msgid "Focus next column in multi-column mode"
msgstr "Focus next column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:135
msgid "Focus previous column in multi-column mode"
msgstr "Focus previous column in multi-column mode"

#: src/components/keyboard-shortcuts-help.jsx:139
msgid "Compose new post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:143
msgid "Compose new post (new window)"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:146
msgid "<0>Shift</0> + <1>c</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:152
msgid "Send post"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:154
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:161
#: src/components/nav-menu.jsx:352
#: src/components/search-form.jsx:211
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:182
#: src/pages/search.jsx:56
#: src/pages/search.jsx:447
msgid "Search"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:169
msgid "Reply (new window)"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:172
msgid "<0>Shift</0> + <1>r</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "Like (favourite)"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:180
msgid "<0>l</0> or <1>f</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:186
#: src/components/status.jsx:1205
#: src/components/status.jsx:3019
#: src/components/status.jsx:3085
msgid "Boost"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:188
msgid "<0>Shift</0> + <1>b</1>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:198
#: src/components/status.jsx:1308
#: src/components/status.jsx:3117
#: src/components/status.jsx:3118
msgid "Bookmark"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:202
msgid "Toggle Cloak mode"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:204
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:210
msgid "Go to Home"
msgstr "Go to Home"

#: src/components/keyboard-shortcuts-help.jsx:214
msgid "Go to Notifications"
msgstr "Go to Notifications"

#: src/components/keyboard-shortcuts-help.jsx:218
msgid "Go to Settings"
msgstr "Go to Settings"

#: src/components/keyboard-shortcuts-help.jsx:222
msgid "Go to Profile"
msgstr "Go to Profile"

#: src/components/keyboard-shortcuts-help.jsx:226
msgid "Go to Bookmarks"
msgstr "Go to Bookmarks"

#: src/components/list-add-edit.jsx:41
msgid "Edit list"
msgstr ""

#: src/components/list-add-edit.jsx:97
msgid "Unable to edit list."
msgstr ""

#: src/components/list-add-edit.jsx:98
msgid "Unable to create list."
msgstr ""

#: src/components/list-add-edit.jsx:126
msgid "Show replies to list members"
msgstr ""

#: src/components/list-add-edit.jsx:129
msgid "Show replies to people I follow"
msgstr ""

#: src/components/list-add-edit.jsx:132
msgid "Don't show replies"
msgstr ""

#: src/components/list-add-edit.jsx:146
msgid "Hide posts on this list from Home/Following"
msgstr ""

#: src/components/list-add-edit.jsx:159
msgid "Delete this list?"
msgstr ""

#: src/components/list-add-edit.jsx:178
msgid "Unable to delete list."
msgstr ""

#: src/components/list-exclusive-badge.jsx:14
#: src/pages/list.jsx:179
#: src/pages/lists.jsx:107
msgid "Posts on this list are hidden from Home/Following"
msgstr "Posts on this list are hidden from Home/Following"

#: src/components/math-block.jsx:141
msgid "Unable to format math"
msgstr "Unable to format math"

#: src/components/math-block.jsx:155
msgid "Math expressions found."
msgstr "Math expressions found."

#. Action to switch from rendered math back to raw (LaTeX) markup
#: src/components/math-block.jsx:158
msgid "Show markup"
msgstr "Show markup"

#. Action to render math expressions from raw (LaTeX) markup
#: src/components/math-block.jsx:163
msgid "Format math"
msgstr "Format math"

#: src/components/media-alt-modal.jsx:48
#: src/components/media.jsx:52
msgid "Media description"
msgstr ""

#: src/components/media-alt-modal.jsx:67
#: src/components/status.jsx:1375
#: src/components/status.jsx:1384
#: src/components/translation-block.jsx:270
msgid "Translate"
msgstr ""

#: src/components/media-alt-modal.jsx:78
#: src/components/status.jsx:1405
msgid "Speak"
msgstr ""

#: src/components/media-attachment.jsx:229
msgid "Uploaded"
msgstr ""

#: src/components/media-attachment.jsx:243
#: src/components/media-attachment.jsx:244
msgid "Video description"
msgstr "Video description"

#: src/components/media-attachment.jsx:245
msgid "Audio description"
msgstr "Audio description"

#. placeholder {0}: prettyBytes( imageSize, )
#. placeholder {0}: prettyBytes( videoSize, )
#. placeholder {1}: prettyBytes(imageSizeLimit)
#. placeholder {1}: prettyBytes(videoSizeLimit)
#: src/components/media-attachment.jsx:280
#: src/components/media-attachment.jsx:302
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."

#. placeholder {0}: NF( i18n.locale, ).format( width, )
#. placeholder {1}: NF(i18n.locale).format(height)
#. placeholder {2}: NF(i18n.locale).format(newWidth)
#. placeholder {3}: NF( i18n.locale, ).format(newHeight)
#: src/components/media-attachment.jsx:292
#: src/components/media-attachment.jsx:314
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."

#: src/components/media-attachment.jsx:324
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Frame rate too high. Uploading might encounter issues."

#: src/components/media-attachment.jsx:401
#: src/compose.jsx:89
msgid "Error"
msgstr ""

#: src/components/media-attachment.jsx:426
msgid "Edit image description"
msgstr "Edit image description"

#: src/components/media-attachment.jsx:427
#: src/components/media-attachment.jsx:428
msgid "Edit video description"
msgstr "Edit video description"

#: src/components/media-attachment.jsx:429
msgid "Edit audio description"
msgstr "Edit audio description"

#: src/components/media-attachment.jsx:474
#: src/components/media-attachment.jsx:528
msgid "Generating description. Please wait…"
msgstr "Generating description. Please wait…"

#. placeholder {0}: e.message
#: src/components/media-attachment.jsx:499
msgid "Failed to generate description: {0}"
msgstr "Failed to generate description: {0}"

#: src/components/media-attachment.jsx:500
msgid "Failed to generate description"
msgstr "Failed to generate description"

#: src/components/media-attachment.jsx:512
#: src/components/media-attachment.jsx:518
#: src/components/media-attachment.jsx:571
msgid "Generate description…"
msgstr ""

#. placeholder {0}: e?.message ? `: ${e.message}` : ''
#: src/components/media-attachment.jsx:558
msgid "Failed to generate description{0}"
msgstr "Failed to generate description{0}"

#. placeholder {0}: localeCode2Text(lang)
#: src/components/media-attachment.jsx:573
msgid "({0}) <0>— experimental</0>"
msgstr ""

#: src/components/media-attachment.jsx:592
msgid "Done"
msgstr ""

#: src/components/media-modal.jsx:409
msgid "Open original media in new window"
msgstr ""

#: src/components/media-modal.jsx:413
msgid "Open original media"
msgstr ""

#: src/components/media-modal.jsx:429
msgid "Attempting to describe image. Please wait…"
msgstr ""

#: src/components/media-modal.jsx:444
msgid "Failed to describe image"
msgstr ""

#: src/components/media-modal.jsx:454
msgid "Describe image…"
msgstr ""

#: src/components/media-modal.jsx:478
msgid "View post"
msgstr ""

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr ""

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr ""

#: src/components/media-post.jsx:133
#: src/components/status-compact.jsx:74
#: src/components/status.jsx:3646
#: src/components/status.jsx:3724
#: src/components/timeline.jsx:1054
#: src/pages/catchup.jsx:80
#: src/pages/catchup.jsx:2055
msgid "Filtered"
msgstr ""

#: src/components/media.jsx:567
msgid "Open file"
msgstr "Open file"

#: src/components/modals.jsx:93
msgid "Post scheduled"
msgstr "Post scheduled"

#: src/components/modals.jsx:94
msgid "Post published. Check it out."
msgstr ""

#: src/components/modals.jsx:96
msgid "Reply scheduled"
msgstr "Reply scheduled"

#: src/components/modals.jsx:97
msgid "Reply posted. Check it out."
msgstr ""

#: src/components/modals.jsx:98
msgid "Post updated. Check it out."
msgstr ""

#: src/components/nav-menu.jsx:130
msgid "Menu"
msgstr ""

#: src/components/nav-menu.jsx:166
msgid "Reload page now to update?"
msgstr ""

#: src/components/nav-menu.jsx:178
msgid "New update available…"
msgstr ""

#: src/components/nav-menu.jsx:197
#: src/components/shortcuts-settings.jsx:143
#: src/pages/following.jsx:23
#: src/pages/following.jsx:156
#: src/pages/following2.jsx:18
#: src/pages/following2.jsx:133
msgctxt "section title"
msgid "Following"
msgstr "Following"

#: src/components/nav-menu.jsx:204
#: src/pages/catchup.jsx:1025
#: src/pages/welcome.jsx:154
msgid "Catch-up"
msgstr ""

#: src/components/nav-menu.jsx:211
#: src/components/shortcuts-settings.jsx:60
#: src/components/shortcuts-settings.jsx:149
#: src/pages/home.jsx:249
#: src/pages/mentions.jsx:25
#: src/pages/mentions.jsx:256
#: src/pages/notifications.jsx:973
#: src/pages/settings.jsx:1329
#: src/pages/trending.jsx:384
msgid "Mentions"
msgstr ""

#: src/components/nav-menu.jsx:218
#: src/components/shortcuts-settings.jsx:51
#: src/components/shortcuts-settings.jsx:155
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:95
#: src/pages/home.jsx:207
#: src/pages/notifications.jsx:146
#: src/pages/notifications.jsx:753
msgid "Notifications"
msgstr ""

#: src/components/nav-menu.jsx:221
msgid "New"
msgstr ""

#: src/components/nav-menu.jsx:232
#: src/components/shortcuts-settings.jsx:61
#: src/components/shortcuts-settings.jsx:192
msgid "Profile"
msgstr ""

#: src/components/nav-menu.jsx:240
#: src/components/shortcuts-settings.jsx:56
#: src/components/shortcuts-settings.jsx:212
#: src/pages/bookmarks.jsx:12
#: src/pages/bookmarks.jsx:26
msgid "Bookmarks"
msgstr ""

#: src/components/nav-menu.jsx:251
#: src/components/text-expander.jsx:215
msgid "More…"
msgstr ""

#: src/components/nav-menu.jsx:260
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:218
#: src/pages/catchup.jsx:1598
#: src/pages/catchup.jsx:2258
#: src/pages/favourites.jsx:12
#: src/pages/favourites.jsx:26
#: src/pages/settings.jsx:1333
msgid "Likes"
msgstr ""

#: src/components/nav-menu.jsx:267
#: src/pages/account-collections.jsx:70
#: src/pages/account-collections.jsx:149
#: src/pages/account-collections.jsx:171
#: src/pages/collection.jsx:269
#: src/pages/search.jsx:164
msgid "Collections"
msgstr "Collections"

#: src/components/nav-menu.jsx:274
#: src/pages/followed-hashtags.jsx:15
#: src/pages/followed-hashtags.jsx:45
msgid "Followed Hashtags"
msgstr ""

#: src/components/nav-menu.jsx:288
#: src/pages/account-statuses.jsx:410
#: src/pages/filters.jsx:55
#: src/pages/filters.jsx:94
#: src/pages/hashtag.jsx:373
msgid "Filters"
msgstr ""

#: src/components/nav-menu.jsx:296
msgid "Muted users"
msgstr ""

#: src/components/nav-menu.jsx:304
msgid "Muted users…"
msgstr ""

#: src/components/nav-menu.jsx:311
msgid "Blocked users"
msgstr ""

#: src/components/nav-menu.jsx:319
msgid "Blocked users…"
msgstr ""

#: src/components/nav-menu.jsx:331
msgid "Accounts…"
msgstr ""

#: src/components/nav-menu.jsx:341
#: src/pages/login.jsx:33
#: src/pages/login.jsx:227
#: src/pages/status.jsx:1110
#: src/pages/welcome.jsx:63
msgid "Log in"
msgstr ""

#: src/components/nav-menu.jsx:359
#: src/components/shortcuts-settings.jsx:59
#: src/components/shortcuts-settings.jsx:175
#: src/pages/trending.jsx:444
msgid "Trending"
msgstr ""

#: src/components/nav-menu.jsx:375
#: src/components/shortcuts-settings.jsx:168
msgid "Federated"
msgstr ""

#: src/components/nav-menu.jsx:399
msgid "Shortcuts / Columns…"
msgstr ""

#: src/components/nav-menu.jsx:409
#: src/components/nav-menu.jsx:423
msgid "Settings…"
msgstr ""

#: src/components/nav-menu.jsx:453
#: src/components/nav-menu.jsx:488
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:161
#: src/pages/list.jsx:127
#: src/pages/lists.jsx:18
#: src/pages/lists.jsx:54
msgid "Lists"
msgstr ""

#: src/components/nav-menu.jsx:461
#: src/components/shortcuts.jsx:32
#: src/pages/list.jsx:139
msgid "All Lists"
msgstr ""

#: src/components/notification-service.jsx:156
msgid "Notification"
msgstr ""

#: src/components/notification-service.jsx:162
msgid "This notification is from your other account."
msgstr ""

#: src/components/notification-service.jsx:191
msgid "View all notifications"
msgstr ""

#: src/components/notification.jsx:80
msgid "{account} reacted to your post with {emojiObject}"
msgstr ""

#: src/components/notification.jsx:87
msgid "{account} published a post."
msgstr ""

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:95
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr ""

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:138
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr ""

#: src/components/notification.jsx:152
msgid "{account} requested to follow you."
msgstr ""

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:161
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:203
msgid "A poll you have voted in or created has ended."
msgstr ""

#: src/components/notification.jsx:204
msgid "A poll you have created has ended."
msgstr ""

#: src/components/notification.jsx:205
msgid "A poll you have voted in has ended."
msgstr ""

#: src/components/notification.jsx:208
msgid "{account} edited a post."
msgstr "{account} edited a post."

#: src/components/notification.jsx:210
msgid "A post you interacted with has been edited."
msgstr ""

#. placeholder {0}: shortenNumber(count)
#. placeholder {1}: shortenNumber(count)
#: src/components/notification.jsx:219
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr ""

#: src/components/notification.jsx:262
msgid "{account} edited a post you have quoted."
msgstr "{account} edited a post you have quoted."

#. placeholder {0}: shortenNumber(count)
#: src/components/notification.jsx:265
msgid "{count, plural, =1 {{account} signed up.} other {<0><1>{0}</1> people</0> signed up.}}"
msgstr "{count, plural, =1 {{account} signed up.} other {<0><1>{0}</1> people</0> signed up.}}"

#: src/components/notification.jsx:279
msgid "{account} reported {targetAccount}"
msgstr ""

#: src/components/notification.jsx:284
msgid "Lost connections with <0>{name}</0>."
msgstr ""

#: src/components/notification.jsx:290
msgid "Moderation warning"
msgstr ""

#: src/components/notification.jsx:296
msgid "Your {year} #Wrapstodon is here!"
msgstr "Your {year} #Wrapstodon is here!"

#: src/components/notification.jsx:298
msgid "{account} added you to a collection."
msgstr "{account} added you to a collection."

#: src/components/notification.jsx:301
msgid "{account} edited a collection you're in."
msgstr "{account} edited a collection you're in."

#: src/components/notification.jsx:308
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr ""

#: src/components/notification.jsx:314
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:320
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr ""

#: src/components/notification.jsx:328
msgid "Your account has received a moderation warning."
msgstr ""

#: src/components/notification.jsx:329
msgid "Your account has been disabled."
msgstr ""

#: src/components/notification.jsx:330
msgid "Some of your posts have been marked as sensitive."
msgstr ""

#: src/components/notification.jsx:331
msgid "Some of your posts have been deleted."
msgstr ""

#: src/components/notification.jsx:332
msgid "Your posts will be marked as sensitive from now on."
msgstr ""

#: src/components/notification.jsx:333
msgid "Your account has been limited."
msgstr ""

#: src/components/notification.jsx:334
msgid "Your account has been suspended."
msgstr ""

#: src/components/notification.jsx:420
msgid "[Unknown notification type: {type}]"
msgstr ""

#: src/components/notification.jsx:498
#: src/components/status.jsx:1322
#: src/components/status.jsx:1332
msgid "Boosted/Liked by…"
msgstr ""

#: src/components/notification.jsx:499
msgid "Liked by…"
msgstr ""

#: src/components/notification.jsx:500
msgid "Boosted by…"
msgstr ""

#: src/components/notification.jsx:501
msgid "Followed by…"
msgstr ""

#: src/components/notification.jsx:645
#: src/components/notification.jsx:661
msgid "Learn more <0/>"
msgstr ""

#: src/components/notification.jsx:670
msgid "View #Wrapstodon"
msgstr "View #Wrapstodon"

#: src/components/notification.jsx:894
#: src/components/quote-chain-modal.jsx:18
#: src/components/status.jsx:266
msgid "Read more →"
msgstr ""

#: src/components/open-link-sheet.jsx:30
#: src/components/related-actions.jsx:573
#: src/components/status.jsx:1496
#: src/pages/collection.jsx:329
msgid "Link copied"
msgstr ""

#: src/components/open-link-sheet.jsx:33
#: src/components/related-actions.jsx:576
#: src/components/status.jsx:1499
#: src/pages/collection.jsx:332
msgid "Unable to copy link"
msgstr ""

#: src/components/open-link-sheet.jsx:56
msgid "Open link?"
msgstr "Open link?"

#: src/components/open-link-sheet.jsx:78
#: src/components/post-embed-modal.jsx:233
#: src/components/related-actions.jsx:582
#: src/components/shortcuts-settings.jsx:1175
#: src/components/status.jsx:1505
#: src/pages/collection.jsx:338
msgid "Copy"
msgstr ""

#: src/components/open-link-sheet.jsx:82
#: src/components/related-actions.jsx:603
#: src/components/status.jsx:1527
#: src/pages/collection.jsx:355
msgid "Share…"
msgstr ""

#: src/components/open-link-sheet.jsx:92
msgid "Open"
msgstr "Open"

#: src/components/poll.jsx:160
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# vote} other {# votes}}"

#: src/components/poll.jsx:167
msgid "Voted"
msgstr "Voted"

#: src/components/poll.jsx:191
#: src/components/poll.jsx:389
#: src/components/poll.jsx:393
msgid "Hide results"
msgstr "Hide results"

#. placeholder {0}: options.length
#: src/components/poll.jsx:196
#: src/components/poll.jsx:290
#: src/components/poll.jsx:306
msgid "{0, plural, one {# choice} other {# choices}}"
msgstr "{0, plural, one {# choice} other {# choices}}"

#: src/components/poll.jsx:222
msgid "Unable to vote in poll"
msgstr "Unable to vote in poll"

#: src/components/poll.jsx:279
msgid "Vote"
msgstr "Vote"

#. placeholder {0}: shortenNumber(votesCount)
#. placeholder {1}: shortenNumber(votesCount)
#: src/components/poll.jsx:316
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"

#. placeholder {0}: shortenNumber(votersCount)
#. placeholder {1}: shortenNumber(votersCount)
#: src/components/poll.jsx:337
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"

#: src/components/poll.jsx:363
msgid "Ended <0/>"
msgstr "Ended <0/>"

#: src/components/poll.jsx:368
msgid "Ended"
msgstr "Ended"

#: src/components/poll.jsx:372
msgid "Ending <0/>"
msgstr "Ending <0/>"

#: src/components/poll.jsx:377
msgid "Ending"
msgstr "Ending"

#: src/components/poll.jsx:389
#: src/components/poll.jsx:393
msgid "Show results"
msgstr "Show results"

#: src/components/poll.jsx:411
#: src/components/poll.jsx:413
#: src/pages/scheduled-posts.jsx:100
#: src/pages/status.jsx:1574
#: src/pages/status.jsx:1597
msgid "Refresh"
msgstr ""

#: src/components/post-embed-modal.jsx:202
#: src/components/status.jsx:1540
msgid "Embed post"
msgstr ""

#: src/components/post-embed-modal.jsx:207
msgid "HTML Code"
msgstr ""

#: src/components/post-embed-modal.jsx:224
msgid "HTML code copied"
msgstr ""

#: src/components/post-embed-modal.jsx:227
msgid "Unable to copy HTML code"
msgstr ""

#: src/components/post-embed-modal.jsx:239
msgid "Media attachments:"
msgstr ""

#: src/components/post-embed-modal.jsx:261
msgid "Account Emojis:"
msgstr ""

#: src/components/post-embed-modal.jsx:292
#: src/components/post-embed-modal.jsx:337
msgid "static URL"
msgstr ""

#: src/components/post-embed-modal.jsx:306
msgid "Emojis:"
msgstr ""

#: src/components/post-embed-modal.jsx:351
msgid "Notes:"
msgstr ""

#: src/components/post-embed-modal.jsx:355
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr ""

#: src/components/post-embed-modal.jsx:361
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr ""

#: src/components/post-embed-modal.jsx:366
msgid "Media attachments can be images, videos, audios or any file types."
msgstr ""

#: src/components/post-embed-modal.jsx:372
msgid "Post could be edited or deleted later."
msgstr ""

#: src/components/post-embed-modal.jsx:378
msgid "Preview"
msgstr ""

#: src/components/post-embed-modal.jsx:387
msgid "Note: This preview is lightly styled."
msgstr ""

#: src/components/private-note-sheet.jsx:41
#: src/components/related-actions.jsx:243
msgid "Notes"
msgstr "Notes"

#: src/components/private-note-sheet.jsx:44
msgid "Only visible to you"
msgstr "Only visible to you"

#: src/components/private-note-sheet.jsx:69
msgid "Unable to update private note."
msgstr "Unable to update private note."

#: src/components/private-note-sheet.jsx:97
msgid "Save & close"
msgstr ""

#: src/components/qr-code-modal.jsx:26
#: src/components/shortcuts-settings.jsx:849
msgid "Scan QR code"
msgstr "Scan QR code"

#: src/components/qr-scanner-modal.jsx:263
msgid "Unable to access camera. Please check permissions."
msgstr "Unable to access camera. Please check permissions."

#: src/components/quote-chain-modal.jsx:107
msgid "Quote chain"
msgstr "Quote chain"

#: src/components/quote-chain-modal.jsx:151
msgid "Failed to unwrap quote chain"
msgstr "Failed to unwrap quote chain"

#: src/components/quote-chain-modal.jsx:165
msgid "Continue unwrapping…"
msgstr "Continue unwrapping…"

#: src/components/quote-settings-sheet.jsx:37
#: src/pages/settings.jsx:341
msgid "Quote settings updated"
msgstr "Quote settings updated"

#: src/components/quote-settings-sheet.jsx:47
#: src/pages/settings.jsx:343
msgid "Failed to update quote settings"
msgstr "Failed to update quote settings"

#: src/components/quote-settings-sheet.jsx:66
msgid "Quote settings for this post"
msgstr "Quote settings for this post"

#: src/components/quote-suggestion.jsx:19
msgid "Turn link into a quote?"
msgstr "Turn link into a quote?"

#: src/components/quote-suggestion.jsx:37
msgid "Keep as link"
msgstr "Keep as link"

#: src/components/quote-suggestion.jsx:42
msgid "Replace current quote"
msgstr "Replace current quote"

#: src/components/quote-suggestion.jsx:44
msgid "Turn into quote"
msgstr "Turn into quote"

#: src/components/quotes-modal.jsx:150
msgid "Error loading quotes"
msgstr "Error loading quotes"

#: src/components/quotes-modal.jsx:154
msgid "No quotes yet"
msgstr "No quotes yet"

#: src/components/recent-searches.jsx:27
msgid "Cleared recent searches"
msgstr "Cleared recent searches"

#: src/components/recent-searches.jsx:49
#: src/components/search-form.jsx:336
msgid "Recent searches"
msgstr "Recent searches"

#: src/components/recent-searches.jsx:59
msgid "Clear all"
msgstr "Clear all"

#: src/components/recent-searches.jsx:94
msgid "Clear"
msgstr ""

#: src/components/related-actions.jsx:43
msgid "Forever"
msgstr ""

#. placeholder {0}: niceDateTime(lastStatusAt, { hideTime: true, })
#: src/components/related-actions.jsx:215
msgid "Last post: <0>{0}</0>"
msgstr ""

#: src/components/related-actions.jsx:229
msgid "Muted"
msgstr ""

#: src/components/related-actions.jsx:234
msgid "Blocked"
msgstr ""

#: src/components/related-actions.jsx:300
msgid "Mention <0>@{username}</0>"
msgstr ""

#: src/components/related-actions.jsx:313
msgid "Search <0>@{username}</0>'s posts"
msgstr "Search <0>@{username}</0>'s posts"

#: src/components/related-actions.jsx:327
msgid "Translate bio"
msgstr ""

#: src/components/related-actions.jsx:337
msgid "Edit notes"
msgstr "Edit notes"

#: src/components/related-actions.jsx:337
msgid "Add notes"
msgstr "Add notes"

#: src/components/related-actions.jsx:356
msgid "Notifications enabled for @{username}'s posts."
msgstr "Notifications enabled for @{username}'s posts."

#: src/components/related-actions.jsx:357
msgid " Notifications disabled for @{username}'s posts."
msgstr " Notifications disabled for @{username}'s posts."

#: src/components/related-actions.jsx:369
msgid "Disable notifications"
msgstr "Disable notifications"

#: src/components/related-actions.jsx:370
msgid "Enable notifications"
msgstr "Enable notifications"

#: src/components/related-actions.jsx:387
msgid "Boosts from @{username} enabled."
msgstr "Boosts from @{username} enabled."

#: src/components/related-actions.jsx:388
msgid "Boosts from @{username} disabled."
msgstr "Boosts from @{username} disabled."

#: src/components/related-actions.jsx:399
msgid "Disable boosts"
msgstr "Disable boosts"

#: src/components/related-actions.jsx:399
msgid "Enable boosts"
msgstr "Enable boosts"

#: src/components/related-actions.jsx:418
msgid "@{username} is no longer featured on your profile."
msgstr "@{username} is no longer featured on your profile."

#: src/components/related-actions.jsx:428
msgid "@{username} is now featured on your profile."
msgstr "@{username} is now featured on your profile."

#: src/components/related-actions.jsx:436
msgid "Unable to unfeature @{username} on your profile."
msgstr "Unable to unfeature @{username} on your profile."

#: src/components/related-actions.jsx:440
msgid "Unable to feature @{username} on your profile."
msgstr "Unable to feature @{username} on your profile."

#: src/components/related-actions.jsx:449
msgid "Don't feature on profile"
msgstr "Don't feature on profile"

#: src/components/related-actions.jsx:450
#: src/pages/hashtag.jsx:362
msgid "Feature on profile"
msgstr ""

#: src/components/related-actions.jsx:459
#: src/components/related-actions.jsx:519
msgid "Show featured profiles"
msgstr "Show featured profiles"

#: src/components/related-actions.jsx:470
#: src/components/related-actions.jsx:530
msgid "Show collections"
msgstr "Show collections"

#: src/components/related-actions.jsx:511
#: src/pages/account-statuses.jsx:578
msgid "Search my posts"
msgstr "Search my posts"

#: src/components/related-actions.jsx:597
#: src/components/shortcuts-settings.jsx:1193
#: src/components/status.jsx:1521
msgid "Sharing doesn't seem to work."
msgstr ""

#: src/components/related-actions.jsx:639
msgid "Unmuted @{username}"
msgstr "Unmuted @{username}"

#: src/components/related-actions.jsx:651
msgid "Unmute <0>@{username}</0>"
msgstr "Unmute <0>@{username}</0>"

#: src/components/related-actions.jsx:667
msgid "Mute <0>@{username}</0>…"
msgstr ""

#. placeholder {0}: typeof MUTE_DURATIONS_LABELS[duration] === 'function' ? MUTE_DURATIONS_LABELS[duration]() : _(MUTE_DURATIONS_LABELS[duration])
#: src/components/related-actions.jsx:699
msgid "Muted @{username} for {0}"
msgstr "Muted @{username} for {0}"

#: src/components/related-actions.jsx:711
msgid "Unable to mute @{username}"
msgstr "Unable to mute @{username}"

#: src/components/related-actions.jsx:732
msgid "Remove <0>@{username}</0> from followers?"
msgstr ""

#: src/components/related-actions.jsx:752
msgid "@{username} removed from followers"
msgstr "@{username} removed from followers"

#: src/components/related-actions.jsx:764
msgid "Remove follower…"
msgstr ""

#: src/components/related-actions.jsx:775
msgid "Block <0>@{username}</0>?"
msgstr ""

#: src/components/related-actions.jsx:799
msgid "Unblocked @{username}"
msgstr "Unblocked @{username}"

#: src/components/related-actions.jsx:807
msgid "Blocked @{username}"
msgstr "Blocked @{username}"

#: src/components/related-actions.jsx:815
msgid "Unable to unblock @{username}"
msgstr "Unable to unblock @{username}"

#: src/components/related-actions.jsx:817
msgid "Unable to block @{username}"
msgstr "Unable to block @{username}"

#: src/components/related-actions.jsx:827
msgid "Unblock <0>@{username}</0>"
msgstr ""

#: src/components/related-actions.jsx:836
msgid "Block <0>@{username}</0>…"
msgstr ""

#: src/components/related-actions.jsx:853
msgid "Report <0>@{username}</0>…"
msgstr ""

#: src/components/related-actions.jsx:921
msgid "Withdraw follow request?"
msgstr "Withdraw follow request?"

#. placeholder {0}: info.acct ? punycode.toUnicode(info.acct) : info.username
#: src/components/related-actions.jsx:922
msgid "Unfollow @{0}?"
msgstr "Unfollow @{0}?"

#: src/components/related-actions.jsx:985
msgid "Unfollow…"
msgstr ""

#: src/components/related-actions.jsx:994
msgid "Withdraw…"
msgstr ""

#. Relative time in seconds, as short as possible
#. placeholder {0}: seconds < 1 ? 1 : Math.floor(seconds)
#: src/components/relative-time.jsx:45
msgid "{0}s"
msgstr ""

#. Relative time in minutes, as short as possible
#. placeholder {0}: Math.floor(seconds / minute)
#: src/components/relative-time.jsx:50
msgid "{0}m"
msgstr ""

#. Relative time in hours, as short as possible
#. placeholder {0}: Math.floor(seconds / hour)
#: src/components/relative-time.jsx:55
msgid "{0}h"
msgstr ""

#: src/components/report-collection.jsx:25
msgid "Report Collection"
msgstr "Report Collection"

#: src/components/report-collection.jsx:60
msgid "Collection reported"
msgstr "Collection reported"

#: src/components/report-collection.jsx:65
msgid "Unable to report collection"
msgstr "Unable to report collection"

#: src/components/report-collection.jsx:73
msgid "Additional comments"
msgstr "Additional comments"

#: src/components/report-collection.jsx:94
#: src/components/report-modal.jsx:299
msgid "Forward to <0>{domain}</0>"
msgstr ""

#: src/components/report-collection.jsx:103
#: src/components/report-modal.jsx:309
msgid "Send Report"
msgstr ""

#: src/components/report-modal.jsx:30
msgid "Spam"
msgstr ""

#: src/components/report-modal.jsx:31
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr ""

#: src/components/report-modal.jsx:34
msgid "Illegal"
msgstr ""

#: src/components/report-modal.jsx:35
msgid "Violates the law of your or the server's country"
msgstr ""

#: src/components/report-modal.jsx:38
msgid "Server rule violation"
msgstr ""

#: src/components/report-modal.jsx:39
msgid "Breaks specific server rules"
msgstr ""

#: src/components/report-modal.jsx:40
msgid "Violation"
msgstr ""

#: src/components/report-modal.jsx:43
msgid "Other"
msgstr ""

#: src/components/report-modal.jsx:44
msgid "Issue doesn't fit other categories"
msgstr ""

#: src/components/report-modal.jsx:111
msgid "Report Post"
msgstr ""

#: src/components/report-modal.jsx:111
msgid "Report @{username}"
msgstr ""

#: src/components/report-modal.jsx:147
msgid "Pending review"
msgstr ""

#: src/components/report-modal.jsx:189
msgid "Post reported"
msgstr ""

#: src/components/report-modal.jsx:189
msgid "Profile reported"
msgstr ""

#: src/components/report-modal.jsx:197
msgid "Unable to report post"
msgstr ""

#: src/components/report-modal.jsx:198
msgid "Unable to report profile"
msgstr ""

#: src/components/report-modal.jsx:206
msgid "What's the issue with this post?"
msgstr ""

#: src/components/report-modal.jsx:207
msgid "What's the issue with this profile?"
msgstr ""

#: src/components/report-modal.jsx:276
msgid "Additional info"
msgstr ""

#: src/components/report-modal.jsx:318
msgid "Muted {username}"
msgstr ""

#: src/components/report-modal.jsx:321
msgid "Unable to mute {username}"
msgstr ""

#: src/components/report-modal.jsx:326
msgid "Send Report <0>+ Mute profile</0>"
msgstr ""

#: src/components/report-modal.jsx:337
msgid "Blocked {username}"
msgstr ""

#: src/components/report-modal.jsx:340
msgid "Unable to block {username}"
msgstr ""

#: src/components/report-modal.jsx:345
msgid "Send Report <0>+ Block profile</0>"
msgstr ""

#: src/components/search-form.jsx:18
msgid "Posts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:26
msgid "Accounts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:37
msgid "Posts tagged with <0>{hashtag}</0>"
msgstr "Posts tagged with <0>{hashtag}</0>"

#: src/components/search-form.jsx:46
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr ""

#: src/components/search-form.jsx:142
msgid "Look up <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:369
#: src/pages/home.jsx:260
msgid "See all"
msgstr ""

#: src/components/shortcuts-settings.jsx:50
msgid "Home / Following"
msgstr ""

#: src/components/shortcuts-settings.jsx:53
msgid "Public (Local / Federated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:55
msgid "Account"
msgstr ""

#: src/components/shortcuts-settings.jsx:58
msgid "Hashtag"
msgstr ""

#: src/components/shortcuts-settings.jsx:66
msgid "List ID"
msgstr ""

#: src/components/shortcuts-settings.jsx:73
msgid "Local only"
msgstr ""

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
#: src/pages/login.jsx:231
msgid "Server"
msgstr "Server"

#: src/components/shortcuts-settings.jsx:81
#: src/components/shortcuts-settings.jsx:90
#: src/components/shortcuts-settings.jsx:128
msgid "Optional, e.g. mastodon.social"
msgstr ""

#: src/components/shortcuts-settings.jsx:96
msgid "Search term"
msgstr ""

#: src/components/shortcuts-settings.jsx:99
msgid "Optional, unless for multi-column mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:116
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr ""

#: src/components/shortcuts-settings.jsx:120
#: src/pages/hashtag.jsx:389
msgid "Media only"
msgstr ""

#: src/components/shortcuts-settings.jsx:252
#: src/components/shortcuts.jsx:347
msgid "Shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:260
msgid "beta"
msgstr ""

#: src/components/shortcuts-settings.jsx:266
msgid "Specify a list of shortcuts that'll appear as:"
msgstr ""

#: src/components/shortcuts-settings.jsx:272
msgid "Floating button"
msgstr ""

#: src/components/shortcuts-settings.jsx:277
msgid "Tab/Menu bar"
msgstr ""

#: src/components/shortcuts-settings.jsx:282
msgid "Multi-column"
msgstr ""

#: src/components/shortcuts-settings.jsx:349
msgid "Not available in current view mode"
msgstr ""

#: src/components/shortcuts-settings.jsx:396
#: src/components/status.jsx:1654
#: src/pages/collection.jsx:400
#: src/pages/list.jsx:195
msgid "Edit"
msgstr ""

#: src/components/shortcuts-settings.jsx:417
msgid "Add more than one shortcut/column to make this work."
msgstr ""

#: src/components/shortcuts-settings.jsx:428
msgid "No columns yet. Tap on the Add column button."
msgstr ""

#: src/components/shortcuts-settings.jsx:429
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr ""

#: src/components/shortcuts-settings.jsx:432
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr ""

#: src/components/shortcuts-settings.jsx:460
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr ""

#: src/components/shortcuts-settings.jsx:461
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:475
#: src/pages/accounts.jsx:367
msgid "Import/export"
msgstr ""

#: src/components/shortcuts-settings.jsx:485
msgid "Add column…"
msgstr ""

#: src/components/shortcuts-settings.jsx:486
msgid "Add shortcut…"
msgstr ""

#: src/components/shortcuts-settings.jsx:533
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:534
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr ""

#: src/components/shortcuts-settings.jsx:535
msgid "Multiple hashtags are supported. Space-separated."
msgstr ""

#: src/components/shortcuts-settings.jsx:604
msgid "Edit shortcut"
msgstr ""

#: src/components/shortcuts-settings.jsx:604
msgid "Add shortcut"
msgstr ""

#: src/components/shortcuts-settings.jsx:640
msgid "Timeline"
msgstr ""

#: src/components/shortcuts-settings.jsx:666
msgid "List"
msgstr ""

#: src/components/shortcuts-settings.jsx:806
msgid "Import/Export <0>Shortcuts</0>"
msgstr ""

#: src/components/shortcuts-settings.jsx:824
msgid "Paste shortcuts here"
msgstr ""

#: src/components/shortcuts-settings.jsx:860
msgid "Downloading saved shortcuts from server…"
msgstr "Downloading saved shortcuts from server…"

#: src/components/shortcuts-settings.jsx:888
msgid "Unable to download shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:891
msgid "Download shortcuts from server"
msgstr "Download shortcuts from server"

#: src/components/shortcuts-settings.jsx:960
msgid "* Exists in current shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:965
msgid "List may not work if it's from a different account."
msgstr ""

#: src/components/shortcuts-settings.jsx:975
msgid "Invalid settings format"
msgstr ""

#: src/components/shortcuts-settings.jsx:983
msgid "Append to current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:986
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:1008
msgid "No new shortcuts to import"
msgstr ""

#: src/components/shortcuts-settings.jsx:1023
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr ""

#: src/components/shortcuts-settings.jsx:1024
#: src/components/shortcuts-settings.jsx:1048
msgid "Shortcuts imported"
msgstr ""

#: src/components/shortcuts-settings.jsx:1034
msgid "Import & append…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1042
msgid "Override current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1043
msgid "Import shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:1057
msgid "or override…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1057
msgid "Import…"
msgstr ""

#: src/components/shortcuts-settings.jsx:1081
msgid "Shortcuts copied"
msgstr ""

#: src/components/shortcuts-settings.jsx:1084
msgid "Unable to copy shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:1136
msgid "Saving shortcuts to server…"
msgstr "Saving shortcuts to server…"

#: src/components/shortcuts-settings.jsx:1143
msgid "Shortcuts saved"
msgstr ""

#: src/components/shortcuts-settings.jsx:1148
msgid "Unable to save shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:1151
msgid "Sync to server"
msgstr "Sync to server"

#: src/components/shortcuts-settings.jsx:1166
msgid "Shortcut settings copied"
msgstr ""

#: src/components/shortcuts-settings.jsx:1169
msgid "Unable to copy shortcut settings"
msgstr ""

#: src/components/shortcuts-settings.jsx:1199
msgid "Share"
msgstr ""

#. placeholder {0}: shortcutsStr.length
#: src/components/shortcuts-settings.jsx:1205
msgid "{0, plural, one {# character} other {# characters}}"
msgstr ""

#: src/components/shortcuts-settings.jsx:1217
msgid "Raw Shortcuts JSON"
msgstr ""

#: src/components/shortcuts-settings.jsx:1230
msgid "Import/export settings from/to server (Very experimental)"
msgstr "Import/export settings from/to server (Very experimental)"

#: src/components/status.jsx:295
msgid "Private posts cannot be quoted"
msgstr "Private posts cannot be quoted"

#: src/components/status.jsx:296
msgid "Request to quote"
msgstr "Request to quote"

#: src/components/status.jsx:297
msgid "Author will manually review"
msgstr "Author will manually review"

#: src/components/status.jsx:298
msgid "Only followers can quote this post"
msgstr "Only followers can quote this post"

#: src/components/status.jsx:299
msgid "You are not allowed to quote this post"
msgstr "You are not allowed to quote this post"

#: src/components/status.jsx:375
#: src/components/status.jsx:3286
#: src/components/status.jsx:3287
#: src/components/status.jsx:3288
msgid "Post unavailable"
msgstr "Post unavailable"

#: src/components/status.jsx:641
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>boosted</1>"

#: src/components/status.jsx:748
msgid "Sorry, your current logged-in server can't interact with this post from another server."
msgstr "Sorry, your current logged-in server can't interact with this post from another server."

#. placeholder {0}: username || acct
#: src/components/status.jsx:938
msgid "Unliked @{0}'s post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:939
msgid "Liked @{0}'s post"
msgstr "Liked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:979
msgid "Unbookmarked @{0}'s post"
msgstr "Unbookmarked @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:980
msgid "Bookmarked @{0}'s post"
msgstr "Bookmarked @{0}'s post"

#: src/components/status.jsx:1084
msgid "Some media have no descriptions."
msgstr ""

#. placeholder {0}: rtf.format(-statusMonthsAgo, 'month')
#: src/components/status.jsx:1091
msgid "Old post (<0>{0}</0>)"
msgstr ""

#: src/components/status.jsx:1112
msgid "Reply…"
msgstr "Reply…"

#: src/components/status.jsx:1126
#: src/components/status.jsx:1140
msgid "Reply all"
msgstr "Reply all"

#: src/components/status.jsx:1129
msgid "{mentionsCount, plural, other {# mentions}}"
msgstr "{mentionsCount, plural, other {# mentions}}"

#. placeholder {0}: mentionsCount - 1
#. placeholder {1}: username || acct
#: src/components/status.jsx:1143
msgid "{0, plural, other {<0>@{1}</0> first, # others below}}"
msgstr "{0, plural, other {<0>@{1}</0> first, # others below}}"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1165
msgid "Only <0>@{0}</0>"
msgstr "Only <0>@{0}</0>"

#: src/components/status.jsx:1205
#: src/components/status.jsx:1283
#: src/components/status.jsx:3019
#: src/components/status.jsx:3083
msgid "Unboost"
msgstr ""

#: src/components/status.jsx:1244
#: src/components/status.jsx:3068
msgid "Quote with link"
msgstr "Quote with link"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1262
#: src/components/status.jsx:1855
msgid "Unboosted @{0}'s post"
msgstr "Unboosted @{0}'s post"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1263
#: src/components/status.jsx:1856
msgid "Boosted @{0}'s post"
msgstr "Boosted @{0}'s post"

#: src/components/status.jsx:1285
#: src/components/status.jsx:3082
msgid "Boost/Quote…"
msgstr "Boost/Quote…"

#: src/components/status.jsx:1286
#: src/components/status.jsx:3082
msgid "Boost…"
msgstr ""

#: src/components/status.jsx:1298
#: src/components/status.jsx:2216
#: src/components/status.jsx:3102
msgid "Unlike"
msgstr ""

#: src/components/status.jsx:1299
#: src/components/status.jsx:2216
#: src/components/status.jsx:2217
#: src/components/status.jsx:3102
#: src/components/status.jsx:3103
msgid "Like"
msgstr ""

#: src/components/status.jsx:1308
#: src/components/status.jsx:3117
msgid "Unbookmark"
msgstr ""

#: src/components/status.jsx:1343
msgid "View Quotes"
msgstr "View Quotes"

#: src/components/status.jsx:1355
msgid "Unwrap quote chain"
msgstr "Unwrap quote chain"

#: src/components/status.jsx:1422
msgid "Post text copied"
msgstr "Post text copied"

#: src/components/status.jsx:1425
msgid "Unable to copy post text"
msgstr "Unable to copy post text"

#: src/components/status.jsx:1431
msgid "Copy post text"
msgstr "Copy post text"

#. placeholder {0}: username || acct
#: src/components/status.jsx:1449
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1470
msgid "Show Edit History"
msgstr ""

#: src/components/status.jsx:1473
msgid "Edited: {editedDateText}"
msgstr ""

#: src/components/status.jsx:1557
msgid "Conversation unmuted"
msgstr ""

#: src/components/status.jsx:1557
msgid "Conversation muted"
msgstr ""

#: src/components/status.jsx:1563
msgid "Unable to unmute conversation"
msgstr ""

#: src/components/status.jsx:1564
msgid "Unable to mute conversation"
msgstr ""

#: src/components/status.jsx:1573
msgid "Unmute conversation"
msgstr ""

#: src/components/status.jsx:1580
msgid "Mute conversation"
msgstr ""

#: src/components/status.jsx:1597
msgid "Post unpinned from profile"
msgstr ""

#: src/components/status.jsx:1598
msgid "Post pinned to profile"
msgstr ""

#: src/components/status.jsx:1603
msgid "Unable to unpin post"
msgstr ""

#: src/components/status.jsx:1603
msgid "Unable to pin post"
msgstr ""

#: src/components/status.jsx:1612
msgid "Unpin from profile"
msgstr ""

#: src/components/status.jsx:1619
msgid "Pin to profile"
msgstr ""

#: src/components/status.jsx:1632
#: src/pages/settings.jsx:315
msgid "Quote settings"
msgstr "Quote settings"

#: src/components/status.jsx:1665
msgid "Delete this post?"
msgstr ""

#: src/components/status.jsx:1681
msgid "Post deleted"
msgstr ""

#: src/components/status.jsx:1684
msgid "Unable to delete post"
msgstr ""

#. placeholder {0}: username || acct
#: src/components/status.jsx:1709
msgid "Remove my post from <0>@{0}</0>'s post?"
msgstr "Remove my post from <0>@{0}</0>'s post?"

#: src/components/status.jsx:1731
msgid "Quote removed"
msgstr "Quote removed"

#: src/components/status.jsx:1735
msgid "Unable to remove quote"
msgstr "Unable to remove quote"

#: src/components/status.jsx:1741
msgid "Remove quote…"
msgstr "Remove quote…"

#: src/components/status.jsx:1755
msgid "Report post…"
msgstr ""

#: src/components/status.jsx:2217
#: src/components/status.jsx:2253
#: src/components/status.jsx:3103
msgid "Liked"
msgstr ""

#: src/components/status.jsx:2250
#: src/components/status.jsx:3085
msgid "Boosted"
msgstr ""

#: src/components/status.jsx:2260
#: src/components/status.jsx:3118
msgid "Bookmarked"
msgstr ""

#: src/components/status.jsx:2264
msgid "Pinned"
msgstr ""

#: src/components/status.jsx:2321
#: src/components/status.jsx:2853
msgid "Deleted"
msgstr ""

#: src/components/status.jsx:2359
#: src/components/status.jsx:2426
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr ""

#: src/components/status.jsx:2371
#: src/components/status.jsx:2438
#: src/components/status.jsx:2885
msgid "Edited"
msgstr ""

#: src/components/status.jsx:2533
#: src/components/status.jsx:2595
#: src/pages/collection.jsx:590
msgid "Show content"
msgstr ""

#: src/components/status.jsx:2533
#: src/components/status.jsx:2595
#: src/components/status.jsx:2702
msgid "Show less"
msgstr ""

#. placeholder {0}: filterInfo.titlesStr
#. placeholder {0}: filterInfo?.titlesStr
#: src/components/status.jsx:2698
#: src/pages/catchup.jsx:2054
msgid "Filtered: {0}"
msgstr "Filtered: {0}"

#: src/components/status.jsx:2702
msgid "Show media"
msgstr ""

#: src/components/status.jsx:2971
#: src/components/status.jsx:2983
msgid "Comments"
msgstr ""

#: src/components/status.jsx:3284
msgid "Post hidden by your filters"
msgstr "Post hidden by your filters"

#: src/components/status.jsx:3285
msgid "Post pending"
msgstr "Post pending"

#: src/components/status.jsx:3289
msgid "Post removed by author"
msgstr "Post removed by author"

#: src/components/status.jsx:3290
msgid "Post hidden because you've blocked @{name}."
msgstr "Post hidden because you've blocked @{name}."

#: src/components/status.jsx:3292
msgid "Post hidden because you've blocked {domain}."
msgstr "Post hidden because you've blocked {domain}."

#: src/components/status.jsx:3293
msgid "Post hidden because you've muted @{name}."
msgstr "Post hidden because you've muted @{name}."

#: src/components/status.jsx:3368
msgid "Show anyway"
msgstr "Show anyway"

#: src/components/status.jsx:3513
msgid "Edit History"
msgstr ""

#: src/components/status.jsx:3517
msgid "Failed to load history"
msgstr ""

#: src/components/status.jsx:3522
msgid "Loading…"
msgstr ""

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3654
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> boosted"

#: src/components/thread-badge.jsx:22
#: src/components/thread-badge.jsx:37
#: src/components/thread-badge.jsx:52
#: src/pages/catchup.jsx:2072
msgid "Thread"
msgstr ""

#: src/components/thread-badge.jsx:28
msgid "Thread {index}/{total}"
msgstr "Thread {index}/{total}"

#. X is the unspecified total number of posts in a thread
#: src/components/thread-badge.jsx:32
msgid "Thread {index}/X"
msgstr "Thread {index}/X"

#. index/total posts in a thread
#: src/components/thread-badge.jsx:41
msgid "{index}/{total}"
msgstr "{index}/{total}"

#. X is the unspecified total number of posts in a thread
#: src/components/thread-badge.jsx:46
msgid "{index}/X"
msgstr "{index}/X"

#: src/components/timeline.jsx:565
#: src/pages/settings.jsx:1357
msgid "New posts"
msgstr ""

#. placeholder {0}: fItems.length
#: src/components/timeline.jsx:701
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Boost} other {# Boosts}}"

#: src/components/timeline.jsx:706
msgid "Pinned posts"
msgstr "Pinned posts"

#. placeholder {0}: filterInfo.titlesStr
#: src/components/timeline.jsx:1049
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr ""

#: src/components/translated-bio-sheet.jsx:26
msgid "Translated Bio"
msgstr ""

#: src/components/translation-block.jsx:226
msgid "Auto-translated from {sourceLangText}"
msgstr ""

#: src/components/translation-block.jsx:265
msgid "Translating…"
msgstr ""

#: src/components/translation-block.jsx:268
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr ""

#: src/components/translation-block.jsx:269
msgid "Translate from {sourceLangText}"
msgstr ""

#. placeholder {0}: detectedLang ?? '…'
#: src/components/translation-block.jsx:297
msgid "Auto ({0})"
msgstr ""

#: src/components/translation-block.jsx:310
msgid "Failed to translate"
msgstr ""

#: src/compose.jsx:38
msgid "Editing source status"
msgstr ""

#. placeholder {0}: replyToStatus.account?.acct || replyToStatus.account?.username
#: src/compose.jsx:40
msgid "Replying to @{0}"
msgstr ""

#: src/compose.jsx:68
msgid "You may close this page now."
msgstr ""

#: src/compose.jsx:76
msgid "Close window"
msgstr ""

#: src/compose.jsx:92
msgid "Login required."
msgstr "Login required."

#: src/compose.jsx:96
#: src/pages/annual-report.jsx:186
#: src/pages/http-route.jsx:94
#: src/pages/login.jsx:309
msgid "Go home"
msgstr ""

#: src/pages/account-collections.jsx:73
msgid "Collections featuring you"
msgstr "Collections featuring you"

#: src/pages/account-collections.jsx:76
msgid "Collections by {username}"
msgstr "Collections by {username}"

#: src/pages/account-collections.jsx:192
msgid "Created by you"
msgstr "Created by you"

#: src/pages/account-collections.jsx:198
msgid "Featuring you"
msgstr "Featuring you"

#. placeholder {0}: collections.length
#: src/pages/account-collections.jsx:241
msgid "{0, plural, one {# collection} other {# collections}}"
msgstr "{0, plural, one {# collection} other {# collections}}"

#: src/pages/account-collections.jsx:256
msgid "Unable to load collections."
msgstr "Unable to load collections."

#: src/pages/account-collections.jsx:265
msgid "No collections featuring you yet."
msgstr "No collections featuring you yet."

#: src/pages/account-collections.jsx:266
msgid "No collections yet."
msgstr "No collections yet."

#: src/pages/account-statuses.jsx:287
msgid "Account posts"
msgstr ""

#: src/pages/account-statuses.jsx:294
msgid "Media posts tagged #{tagged} by {accountDisplay}"
msgstr "Media posts tagged #{tagged} by {accountDisplay}"

#: src/pages/account-statuses.jsx:296
msgid "Posts tagged #{tagged} by {accountDisplay}"
msgstr "Posts tagged #{tagged} by {accountDisplay}"

#: src/pages/account-statuses.jsx:303
msgid "Posts in {monthYear} by {accountDisplay}"
msgstr "Posts in {monthYear} by {accountDisplay}"

#: src/pages/account-statuses.jsx:305
msgid "Media posts by {accountDisplay}"
msgstr "Media posts by {accountDisplay}"

#: src/pages/account-statuses.jsx:394
#: src/pages/account-statuses.jsx:403
#: src/pages/catchup.jsx:1293
msgid "Reset filters"
msgstr ""

#: src/pages/account-statuses.jsx:422
msgid "Showing replies"
msgstr "Showing replies"

#: src/pages/account-statuses.jsx:424
msgid "Hiding replies"
msgstr "Hiding replies"

#: src/pages/account-statuses.jsx:438
msgid "Showing boosts"
msgstr "Showing boosts"

#: src/pages/account-statuses.jsx:440
msgid "Hiding boosts"
msgstr "Hiding boosts"

#: src/pages/account-statuses.jsx:457
msgid "Showing posts with media"
msgstr ""

#. placeholder {0}: tag.name
#: src/pages/account-statuses.jsx:492
msgid "Showing posts tagged with #{0}"
msgstr ""

#. placeholder {0}: date.toLocaleString( i18n.locale, { month: 'long', year: 'numeric', }, )
#: src/pages/account-statuses.jsx:532
msgid "Showing posts in {0}"
msgstr "Showing posts in {0}"

#. placeholder {0}: account?.username
#: src/pages/account-statuses.jsx:579
msgid "Search @{0}'s posts"
msgstr "Search @{0}'s posts"

#: src/pages/account-statuses.jsx:628
#: src/pages/search.jsx:176
#: src/pages/search.jsx:475
msgid "Posts"
msgstr ""

#: src/pages/account-statuses.jsx:653
msgid "Nothing to see here yet."
msgstr ""

#: src/pages/account-statuses.jsx:654
#: src/pages/public.jsx:130
#: src/pages/trending.jsx:452
msgid "Unable to load posts"
msgstr ""

#: src/pages/account-statuses.jsx:695
#: src/pages/account-statuses.jsx:725
msgid "Unable to fetch account info"
msgstr ""

#. placeholder {0}: accountInstance ? ( <> {' '} (<b>{punycode.toUnicode(accountInstance)}</b>) </> ) : null
#: src/pages/account-statuses.jsx:702
msgid "Switch to account's server {0}"
msgstr "Switch to account's server {0}"

#: src/pages/account-statuses.jsx:732
#: src/pages/collection.jsx:504
msgid "Switch to my server (<0>{currentInstance}</0>)"
msgstr "Switch to my server (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:805
msgid "Month"
msgstr ""

#: src/pages/accounts.jsx:92
msgid "Current"
msgstr ""

#: src/pages/accounts.jsx:141
msgid "Logged out"
msgstr "Logged out"

#: src/pages/accounts.jsx:147
msgid "Default"
msgstr ""

#: src/pages/accounts.jsx:169
msgid "Switch to this account"
msgstr "Switch to this account"

#: src/pages/accounts.jsx:178
msgid "Switch in new tab/window"
msgstr "Switch in new tab/window"

#: src/pages/accounts.jsx:192
msgid "View profile…"
msgstr ""

#: src/pages/accounts.jsx:210
msgid "Set as default"
msgstr ""

#: src/pages/accounts.jsx:253
msgid "Log out <0>@{unicodeAcct}</0>?"
msgstr "Log out <0>@{unicodeAcct}</0>?"

#: src/pages/accounts.jsx:282
msgid "Log out and remove <0>@{unicodeAcct}</0>"
msgstr "Log out and remove <0>@{unicodeAcct}</0>"

#: src/pages/accounts.jsx:294
msgid "Log out…"
msgstr ""

#: src/pages/accounts.jsx:304
msgid "Remove <0>@{unicodeAcct}</0>?"
msgstr "Remove <0>@{unicodeAcct}</0>?"

#: src/pages/accounts.jsx:322
msgid "Remove account…"
msgstr "Remove account…"

#. placeholder {0}: niceDateTime(account.createdAt)
#: src/pages/accounts.jsx:330
msgid "Connected on {0} (<0/>)"
msgstr "Connected on {0} (<0/>)"

#: src/pages/accounts.jsx:347
msgid "Add an existing account"
msgstr ""

#: src/pages/accounts.jsx:354
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr ""

#: src/pages/bookmarks.jsx:28
msgid "No bookmarks yet. Go bookmark something!"
msgstr "No bookmarks yet. Go bookmark something!"

#: src/pages/bookmarks.jsx:29
msgid "Unable to load bookmarks."
msgstr ""

#: src/pages/catchup.jsx:58
msgid "last 1 hour"
msgstr ""

#: src/pages/catchup.jsx:59
msgid "last 2 hours"
msgstr ""

#: src/pages/catchup.jsx:60
msgid "last 3 hours"
msgstr ""

#: src/pages/catchup.jsx:61
msgid "last 4 hours"
msgstr ""

#: src/pages/catchup.jsx:62
msgid "last 5 hours"
msgstr ""

#: src/pages/catchup.jsx:63
msgid "last 6 hours"
msgstr ""

#: src/pages/catchup.jsx:64
msgid "last 7 hours"
msgstr ""

#: src/pages/catchup.jsx:65
msgid "last 8 hours"
msgstr ""

#: src/pages/catchup.jsx:66
msgid "last 9 hours"
msgstr ""

#: src/pages/catchup.jsx:67
msgid "last 10 hours"
msgstr ""

#: src/pages/catchup.jsx:68
msgid "last 11 hours"
msgstr ""

#: src/pages/catchup.jsx:69
msgid "last 12 hours"
msgstr ""

#: src/pages/catchup.jsx:70
msgid "beyond 12 hours"
msgstr ""

#: src/pages/catchup.jsx:78
msgid "Followed tags"
msgstr ""

#: src/pages/catchup.jsx:79
msgid "Groups"
msgstr ""

#: src/pages/catchup.jsx:722
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} quotes {quotes} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} quotes {quotes} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"

#: src/pages/catchup.jsx:1036
#: src/pages/catchup.jsx:1060
msgid "Catch-up <0>beta</0>"
msgstr ""

#: src/pages/catchup.jsx:1050
#: src/pages/catchup.jsx:1738
msgid "Help"
msgstr ""

#: src/pages/catchup.jsx:1066
msgid "What is this?"
msgstr ""

#: src/pages/catchup.jsx:1069
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr ""

#: src/pages/catchup.jsx:1080
msgid "Preview of Catch-up UI"
msgstr "Preview of Catch-up UI"

#: src/pages/catchup.jsx:1089
msgid "Let's catch up"
msgstr ""

#: src/pages/catchup.jsx:1094
msgid "Let's catch up on the posts from your followings."
msgstr ""

#: src/pages/catchup.jsx:1098
msgid "Show me all posts from…"
msgstr ""

#: src/pages/catchup.jsx:1121
msgid "until the max"
msgstr "until the max"

#: src/pages/catchup.jsx:1154
msgid "Catch up"
msgstr ""

#: src/pages/catchup.jsx:1160
msgid "Overlaps with your last catch-up"
msgstr ""

#. placeholder {0}: dtf.format(new Date(lastCatchupEndAt))
#: src/pages/catchup.jsx:1172
msgid "Until the last catch-up ({0})"
msgstr ""

#: src/pages/catchup.jsx:1181
msgid "Note: your server might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Note: your server might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."

#: src/pages/catchup.jsx:1191
msgid "Previously…"
msgstr ""

#. placeholder {0}: pc.count
#: src/pages/catchup.jsx:1209
msgid "{0, plural, one {# post} other {# posts}}"
msgstr ""

#: src/pages/catchup.jsx:1219
msgid "Remove this catch-up?"
msgstr "Remove this catch-up?"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1222
msgid "Removing Catch-up {0}"
msgstr "Removing Catch-up {0}"

#. placeholder {0}: pc.id
#: src/pages/catchup.jsx:1226
msgid "Catch-up {0} removed"
msgstr "Catch-up {0} removed"

#: src/pages/catchup.jsx:1240
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr ""

#: src/pages/catchup.jsx:1255
msgid "Fetching posts…"
msgstr ""

#: src/pages/catchup.jsx:1258
msgid "This might take a while."
msgstr ""

#: src/pages/catchup.jsx:1301
#: src/pages/catchup.jsx:1744
msgid "Top links"
msgstr ""

#. placeholder {0}: sharers.map((s) => { const { avatarStatic, displayName } = s; return ( <button type="button" class="plain" style={{ padding: 0, }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); // Reset and filter to author const { id } = s; setSelectedAuthor(id); setSelectedFilterCategory('all'); }} > <Avatar url={avatarStatic} size="s" alt={displayName} /> </button> ); })
#: src/pages/catchup.jsx:1414
msgid "Shared by {0}"
msgstr ""

#: src/pages/catchup.jsx:1469
#: src/pages/mentions.jsx:235
#: src/pages/search.jsx:460
msgid "All"
msgstr ""

#. placeholder {0}: authorCountsList.length
#: src/pages/catchup.jsx:1554
msgid "{0, plural, one {# author} other {# authors}}"
msgstr ""

#: src/pages/catchup.jsx:1566
#: src/pages/collection.jsx:362
msgid "Sort"
msgstr ""

#: src/pages/catchup.jsx:1596
msgid "Date"
msgstr "Date"

#: src/pages/catchup.jsx:1601
msgid "Density"
msgstr "Density"

#: src/pages/catchup.jsx:1624
msgctxt "grouping"
msgid "Group"
msgstr "Group"

#: src/pages/catchup.jsx:1639
msgid "Authors"
msgstr "Authors"

#: src/pages/catchup.jsx:1640
msgid "None"
msgstr "None"

#: src/pages/catchup.jsx:1656
msgid "Show all authors"
msgstr ""

#: src/pages/catchup.jsx:1707
msgid "You don't have to read everything."
msgstr "You don't have to read everything."

#: src/pages/catchup.jsx:1708
msgid "That's all."
msgstr "That's all."

#: src/pages/catchup.jsx:1716
msgid "Back to top"
msgstr ""

#: src/pages/catchup.jsx:1747
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr ""

#: src/pages/catchup.jsx:1753
msgid "Sort: Density"
msgstr ""

#: src/pages/catchup.jsx:1756
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr ""

#: src/pages/catchup.jsx:1763
msgid "Group: Authors"
msgstr ""

#: src/pages/catchup.jsx:1766
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr ""

#: src/pages/catchup.jsx:1813
msgid "Next author"
msgstr ""

#: src/pages/catchup.jsx:1821
msgid "Previous author"
msgstr ""

#: src/pages/catchup.jsx:1837
msgid "Scroll to top"
msgstr ""

#: src/pages/collection.jsx:58
msgid "Date added"
msgstr "Date added"

#. Sort by name
#: src/pages/collection.jsx:61
msgctxt "sorting"
msgid "Name"
msgstr "Name"

#: src/pages/collection.jsx:67
msgid "Last active"
msgstr "Last active"

#: src/pages/collection.jsx:68
msgid "Most followers"
msgstr "Most followers"

#: src/pages/collection.jsx:173
#: src/pages/collection.jsx:174
#: src/pages/collection.jsx:278
msgid "Collection"
msgstr "Collection"

#: src/pages/collection.jsx:209
msgid "Removed from collection"
msgstr "Removed from collection"

#: src/pages/collection.jsx:212
msgid "Unable to remove from collection"
msgstr "Unable to remove from collection"

#: src/pages/collection.jsx:318
msgid "Post collection"
msgstr "Post collection"

#: src/pages/collection.jsx:458
msgid "Report collection…"
msgstr "Report collection…"

#: src/pages/collection.jsx:468
#: src/pages/status.jsx:1648
msgid "Experimental"
msgstr ""

#: src/pages/collection.jsx:496
#: src/pages/status.jsx:1145
msgid "Error: {e}"
msgstr ""

#: src/pages/collection.jsx:515
msgid "Switch to collection's server ({serverDomain})"
msgstr "Switch to collection's server ({serverDomain})"

#: src/pages/collection.jsx:539
msgid "Unable to load collection."
msgstr "Unable to load collection."

#: src/pages/collection.jsx:557
msgid "<link><icon/> Collection</link> by <name/>"
msgstr "<link><icon/> Collection</link> by <name/>"

#: src/pages/collection.jsx:634
msgid "No accounts in this collection yet."
msgstr "No accounts in this collection yet."

#: src/pages/collection.jsx:697
msgid "Marked as sensitive"
msgstr "Marked as sensitive"

#: src/pages/favourites.jsx:28
msgid "No likes yet. Go like something!"
msgstr "No likes yet. Go like something!"

#: src/pages/favourites.jsx:29
msgid "Unable to load likes."
msgstr ""

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr ""

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr ""

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr ""

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr ""

#: src/pages/filters.jsx:42
msgid "Never"
msgstr ""

#: src/pages/filters.jsx:104
#: src/pages/filters.jsx:229
msgid "New filter"
msgstr ""

#. placeholder {0}: filters.length
#: src/pages/filters.jsx:152
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr ""

#: src/pages/filters.jsx:167
msgid "Unable to load filters."
msgstr ""

#: src/pages/filters.jsx:171
msgid "No filters yet."
msgstr ""

#: src/pages/filters.jsx:178
msgid "Add filter"
msgstr ""

#: src/pages/filters.jsx:229
msgid "Edit filter"
msgstr ""

#: src/pages/filters.jsx:346
msgid "Unable to edit filter"
msgstr ""

#: src/pages/filters.jsx:347
msgid "Unable to create filter"
msgstr ""

#: src/pages/filters.jsx:356
msgid "Title"
msgstr ""

#: src/pages/filters.jsx:399
msgid "Whole word"
msgstr ""

#: src/pages/filters.jsx:425
msgid "No keywords. Add one."
msgstr ""

#: src/pages/filters.jsx:452
msgid "Add keyword"
msgstr ""

#. placeholder {0}: filteredEditKeywords.length
#: src/pages/filters.jsx:456
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr ""

#: src/pages/filters.jsx:469
msgid "Filter from…"
msgstr ""

#: src/pages/filters.jsx:495
msgid "* Not implemented yet"
msgstr ""

#: src/pages/filters.jsx:501
msgid "Status: <0><1/></0>"
msgstr ""

#: src/pages/filters.jsx:510
msgid "Change expiry"
msgstr ""

#: src/pages/filters.jsx:510
msgid "Expiry"
msgstr ""

#: src/pages/filters.jsx:529
msgid "Filtered post will be…"
msgstr ""

#: src/pages/filters.jsx:540
msgid "obscured (media only)"
msgstr "obscured (media only)"

#: src/pages/filters.jsx:554
msgid "minimized"
msgstr ""

#: src/pages/filters.jsx:564
msgid "hidden"
msgstr ""

#: src/pages/filters.jsx:581
msgid "Delete this filter?"
msgstr ""

#: src/pages/filters.jsx:594
msgid "Unable to delete filter."
msgstr ""

#: src/pages/filters.jsx:627
msgid "Expired"
msgstr ""

#: src/pages/filters.jsx:629
msgid "Expiring <0/>"
msgstr ""

#: src/pages/filters.jsx:633
msgid "Never expires"
msgstr ""

#. placeholder {0}: followedHashtags.length
#: src/pages/followed-hashtags.jsx:71
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr ""

#: src/pages/followed-hashtags.jsx:86
msgid "Unable to load followed hashtags."
msgstr ""

#: src/pages/followed-hashtags.jsx:90
msgid "No hashtags followed yet."
msgstr ""

#: src/pages/following.jsx:158
#: src/pages/following2.jsx:135
msgid "Nothing to see here."
msgstr ""

#: src/pages/following.jsx:159
#: src/pages/following2.jsx:136
#: src/pages/list.jsx:109
msgid "Unable to load posts."
msgstr ""

#: src/pages/hashtag.jsx:57
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Media only) on {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} on {instance}"

#: src/pages/hashtag.jsx:60
msgid "{hashtagTitle} (Media only)"
msgstr ""

#: src/pages/hashtag.jsx:61
msgid "{hashtagTitle}"
msgstr ""

#: src/pages/hashtag.jsx:210
#: src/pages/public.jsx:125
msgid "This timeline is disabled on this server."
msgstr "This timeline is disabled on this server."

#: src/pages/hashtag.jsx:212
#: src/pages/public.jsx:127
msgid "Login required to see posts from this server."
msgstr "Login required to see posts from this server."

#: src/pages/hashtag.jsx:213
msgid "No one has posted anything with this tag yet."
msgstr ""

#: src/pages/hashtag.jsx:215
msgid "Unable to load posts with this tag"
msgstr ""

#: src/pages/hashtag.jsx:241
msgid "Unfollow #{hashtag}?"
msgstr "Unfollow #{hashtag}?"

#: src/pages/hashtag.jsx:256
msgid "Unfollowed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:271
msgid "Followed #{hashtag}"
msgstr ""

#: src/pages/hashtag.jsx:287
msgid "Following…"
msgstr ""

#: src/pages/hashtag.jsx:316
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:330
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:339
#: src/pages/hashtag.jsx:355
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:427
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr ""

#: src/pages/hashtag.jsx:430
msgid "Add hashtag"
msgstr ""

#: src/pages/hashtag.jsx:463
msgid "Remove hashtag"
msgstr ""

#: src/pages/hashtag.jsx:477
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:506
msgid "This shortcut already exists"
msgstr ""

#: src/pages/hashtag.jsx:509
msgid "Hashtag shortcut added"
msgstr ""

#: src/pages/hashtag.jsx:515
msgid "Add to Shortcuts"
msgstr ""

#: src/pages/hashtag.jsx:521
#: src/pages/public.jsx:172
#: src/pages/trending.jsx:481
msgid "Enter a new server e.g. \"mastodon.social\""
msgstr "Enter a new server e.g. \"mastodon.social\""

#: src/pages/hashtag.jsx:524
#: src/pages/public.jsx:175
#: src/pages/trending.jsx:484
msgid "Invalid server"
msgstr "Invalid server"

#: src/pages/hashtag.jsx:538
#: src/pages/public.jsx:189
#: src/pages/trending.jsx:496
msgid "Go to another server…"
msgstr "Go to another server…"

#: src/pages/hashtag.jsx:551
#: src/pages/public.jsx:202
#: src/pages/trending.jsx:507
msgid "Go to my server (<0>{currentInstance}</0>)"
msgstr "Go to my server (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:233
msgid "Unable to fetch notifications."
msgstr ""

#: src/pages/home.jsx:254
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr ""

#: src/pages/http-route.jsx:71
msgid "Resolving…"
msgstr ""

#: src/pages/http-route.jsx:82
msgid "Unable to resolve URL"
msgstr ""

#: src/pages/list.jsx:108
msgid "Nothing yet."
msgstr ""

#: src/pages/list.jsx:201
#: src/pages/list.jsx:307
msgid "Manage members"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/list.jsx:342
msgid "Remove <0>@{0}</0> from list?"
msgstr ""

#. placeholder {0}: lists.length
#: src/pages/lists.jsx:115
msgid "{0, plural, one {# list} other {# lists}}"
msgstr ""

#: src/pages/lists.jsx:135
msgid "No lists yet."
msgstr ""

#: src/pages/login.jsx:125
#: src/pages/login.jsx:137
msgid "Failed to register application"
msgstr "Failed to register application"

#: src/pages/login.jsx:246
msgid "server domain"
msgstr "server domain"

#: src/pages/login.jsx:271
msgid "e.g. “mastodon.social”"
msgstr ""

#: src/pages/login.jsx:282
msgid "Failed to log in. Please try again or try another server."
msgstr "Failed to log in. Please try again or try another server."

#: src/pages/login.jsx:294
msgid "Continue with {selectedInstanceText}"
msgstr ""

#: src/pages/login.jsx:295
msgid "Continue"
msgstr ""

#: src/pages/login.jsx:303
msgid "Don't have an account? Create one!"
msgstr ""

#: src/pages/mentions.jsx:25
msgid "Private mentions"
msgstr ""

#: src/pages/mentions.jsx:221
msgid "Only followings"
msgstr "Only followings"

#: src/pages/mentions.jsx:247
msgid "Private"
msgstr ""

#: src/pages/mentions.jsx:258
msgid "No one mentioned you :("
msgstr ""

#: src/pages/mentions.jsx:259
msgid "Unable to load mentions."
msgstr ""

#: src/pages/notifications.jsx:136
msgid "People you don't follow"
msgstr "People you don't follow"

#: src/pages/notifications.jsx:137
msgid "People not following you"
msgstr "People not following you"

#: src/pages/notifications.jsx:138
msgid "New accounts"
msgstr "New accounts"

#: src/pages/notifications.jsx:139
msgid "Unsolicited private mentions"
msgstr "Unsolicited private mentions"

#: src/pages/notifications.jsx:140
msgid "Moderated accounts"
msgstr "Moderated accounts"

#: src/pages/notifications.jsx:141
msgid "Bot accounts"
msgstr "Bot accounts"

#: src/pages/notifications.jsx:767
#: src/pages/notifications.jsx:1124
msgid "Notifications settings"
msgstr ""

#: src/pages/notifications.jsx:785
msgid "New notifications"
msgstr ""

#. placeholder {0}: announcements.length
#: src/pages/notifications.jsx:796
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr ""

#: src/pages/notifications.jsx:843
#: src/pages/settings.jsx:1345
msgid "Follow requests"
msgstr ""

#. placeholder {0}: followRequests.length
#: src/pages/notifications.jsx:848
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr ""

#. placeholder {0}: notificationsPolicy.summary.pendingRequestsCount
#: src/pages/notifications.jsx:903
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:986
msgid "Only mentions"
msgstr ""

#: src/pages/notifications.jsx:992
msgid "Today"
msgstr ""

#: src/pages/notifications.jsx:997
msgid "You're all caught up."
msgstr ""

#: src/pages/notifications.jsx:1024
msgid "Yesterday"
msgstr ""

#: src/pages/notifications.jsx:1072
msgid "Unable to load notifications"
msgstr ""

#: src/pages/notifications.jsx:1155
msgid "Notifications settings updated"
msgstr ""

#: src/pages/notifications.jsx:1163
msgid "Filter notifications from:"
msgstr "Filter notifications from:"

#: src/pages/notifications.jsx:1179
msgid "Filter"
msgstr ""

#: src/pages/notifications.jsx:1182
msgid "Ignore"
msgstr ""

#. placeholder {0}: niceDateTime(updatedAtDate)
#: src/pages/notifications.jsx:1255
msgid "Updated <0>{0}</0>"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1323
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#. placeholder {0}: account.username
#: src/pages/notifications.jsx:1344
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1413
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1418
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1423
msgid "Allow"
msgstr ""

#. placeholder {0}: request.account.username
#: src/pages/notifications.jsx:1444
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Notifications from @{0} will not show up in Filtered notifications from now on."

#: src/pages/notifications.jsx:1449
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1454
msgid "Dismiss"
msgstr ""

#: src/pages/notifications.jsx:1469
msgid "Dismissed"
msgstr ""

#: src/pages/public.jsx:30
msgid "Local timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:31
msgid "Federated timeline ({instance})"
msgstr ""

#: src/pages/public.jsx:117
msgid "Local timeline"
msgstr ""

#: src/pages/public.jsx:117
msgid "Federated timeline"
msgstr ""

#: src/pages/public.jsx:128
msgid "No one has posted anything yet."
msgstr ""

#: src/pages/public.jsx:156
msgid "Switch to Federated"
msgstr "Switch to Federated"

#: src/pages/public.jsx:163
msgid "Switch to Local"
msgstr "Switch to Local"

#: src/pages/scheduled-posts.jsx:110
msgid "No scheduled posts."
msgstr "No scheduled posts."

#. Scheduled [in 1 day] ([Thu, Feb 27, 6:30:00 PM])
#. placeholder {0}: niceDateTime(scheduledAt, { formatOpts: { weekday: 'short', second: 'numeric', }, })
#: src/pages/scheduled-posts.jsx:210
msgid "Scheduled <0><1/></0> <2>({0})</2>"
msgstr "Scheduled <0><1/></0> <2>({0})</2>"

#. Scheduled [in 1 day]
#: src/pages/scheduled-posts.jsx:292
msgid "Scheduled <0><1/></0>"
msgstr "Scheduled <0><1/></0>"

#: src/pages/scheduled-posts.jsx:337
msgid "Scheduled post rescheduled"
msgstr "Scheduled post rescheduled"

#: src/pages/scheduled-posts.jsx:344
msgid "Failed to reschedule post"
msgstr "Failed to reschedule post"

#: src/pages/scheduled-posts.jsx:367
msgid "Reschedule"
msgstr "Reschedule"

#: src/pages/scheduled-posts.jsx:373
msgid "Delete scheduled post?"
msgstr "Delete scheduled post?"

#: src/pages/scheduled-posts.jsx:381
msgid "Scheduled post deleted"
msgstr "Scheduled post deleted"

#: src/pages/scheduled-posts.jsx:388
msgid "Failed to delete scheduled post"
msgstr "Failed to delete scheduled post"

#: src/pages/search.jsx:60
msgid "Search: {q} (Posts)"
msgstr ""

#: src/pages/search.jsx:63
msgid "Search: {q} (Accounts)"
msgstr ""

#: src/pages/search.jsx:66
msgid "Search: {q} (Hashtags)"
msgstr ""

#: src/pages/search.jsx:69
msgid "Search: {q}"
msgstr ""

#: src/pages/search.jsx:126
msgid "See more accounts"
msgstr ""

#: src/pages/search.jsx:127
msgid "No accounts found."
msgstr ""

#: src/pages/search.jsx:143
#: src/pages/search.jsx:470
msgid "Hashtags"
msgstr ""

#: src/pages/search.jsx:144
msgid "See more hashtags"
msgstr ""

#: src/pages/search.jsx:145
msgid "No hashtags found."
msgstr ""

#: src/pages/search.jsx:177
msgid "See more posts"
msgstr ""

#: src/pages/search.jsx:178
msgid "No posts found."
msgstr ""

#: src/pages/search.jsx:503
msgid "See more"
msgstr ""

#: src/pages/search.jsx:576
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:105
msgid "Settings"
msgstr ""

#: src/pages/settings.jsx:114
msgid "Appearance"
msgstr ""

#: src/pages/settings.jsx:190
msgid "Light"
msgstr ""

#: src/pages/settings.jsx:201
msgid "Dark"
msgstr ""

#: src/pages/settings.jsx:214
msgid "Auto"
msgstr ""

#: src/pages/settings.jsx:224
msgid "Text size"
msgstr ""

#: src/pages/settings.jsx:232
msgid "Display language"
msgstr ""

#: src/pages/settings.jsx:240
msgid "Volunteer translations"
msgstr "Volunteer translations"

#: src/pages/settings.jsx:255
msgid "Keep navigation bars visible while scrolling"
msgstr "Keep navigation bars visible while scrolling"

#: src/pages/settings.jsx:263
msgid "Posting"
msgstr ""

#: src/pages/settings.jsx:269
msgid "Default visibility"
msgstr ""

#: src/pages/settings.jsx:270
#: src/pages/settings.jsx:316
#: src/pages/settings.jsx:364
msgid "Synced"
msgstr ""

#: src/pages/settings.jsx:293
msgid "Default visibility updated"
msgstr "Default visibility updated"

#: src/pages/settings.jsx:295
msgid "Failed to update default visibility"
msgstr "Failed to update default visibility"

#: src/pages/settings.jsx:366
msgid "Synced to your server's settings. <0>Go to your server ({instance}) for more settings.</0>"
msgstr "Synced to your server's settings. <0>Go to your server ({instance}) for more settings.</0>"

#: src/pages/settings.jsx:383
msgid "Wellbeing"
msgstr "Wellbeing"

#: src/pages/settings.jsx:396
msgid "Hide Trending timeline"
msgstr "Hide Trending timeline"

#: src/pages/settings.jsx:408
msgid "Hide Local timeline"
msgstr "Hide Local timeline"

#: src/pages/settings.jsx:421
msgid "Hide Federated timeline"
msgstr "Hide Federated timeline"

#: src/pages/settings.jsx:429
msgid "Experiments"
msgstr ""

#: src/pages/settings.jsx:442
msgid "Auto refresh timeline posts"
msgstr ""

#: src/pages/settings.jsx:454
msgid "Boosts carousel"
msgstr ""

#: src/pages/settings.jsx:471
msgid "Post translation"
msgstr ""

#: src/pages/settings.jsx:482
msgid "Translate to "
msgstr "Translate to "

#: src/pages/settings.jsx:493
msgid "System language ({systemTargetLanguageText})"
msgstr ""

#. placeholder {0}: snapStates.settings.contentTranslationHideLanguages .length
#: src/pages/settings.jsx:519
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr ""

#: src/pages/settings.jsx:574
msgid "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."
msgstr "Note: This feature uses external translation services, powered by <0>{TRANSLATION_API_NAME}</0>."

#: src/pages/settings.jsx:602
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:606
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:627
msgid "Paginated timeline (beta)"
msgstr "Paginated timeline (beta)"

#: src/pages/settings.jsx:631
msgid "Manual pagination of timeline posts instead of infinite scrolling. Only works for Home/Following timeline for now. Auto refresh and boosts carousel will not work when this is enabled."
msgstr "Manual pagination of timeline posts instead of infinite scrolling. Only works for Home/Following timeline for now. Auto refresh and boosts carousel will not work when this is enabled."

#: src/pages/settings.jsx:651
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:655
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr ""

#: src/pages/settings.jsx:684
msgid "Image description generator"
msgstr ""

#: src/pages/settings.jsx:689
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:696
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr ""

#: src/pages/settings.jsx:724
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr ""

#: src/pages/settings.jsx:729
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr ""

#: src/pages/settings.jsx:740
msgid "Note: This feature uses currently-logged-in server API."
msgstr "Note: This feature uses currently-logged-in server API."

#: src/pages/settings.jsx:756
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:765
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:794
msgid "Install {CLIENT_NAME}"
msgstr "Install {CLIENT_NAME}"

#: src/pages/settings.jsx:802
msgid "About"
msgstr ""

#: src/pages/settings.jsx:841
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:870
msgid "Sponsor"
msgstr ""

#: src/pages/settings.jsx:878
msgid "Donate"
msgstr "Donate"

#: src/pages/settings.jsx:894
msgid "What's new"
msgstr "What's new"

#: src/pages/settings.jsx:898
msgid "Privacy Policy"
msgstr ""

#. placeholder {0}: WEBSITE.replace(/https?:\/\//g, '').replace(/\/$/, '')
#: src/pages/settings.jsx:905
msgid "<0>Site:</0> {0}"
msgstr ""

#. placeholder {0}: !__FAKE_COMMIT_HASH__ && ( <span class="ib insignificant"> ( <a href={`https://github.com/cheeaun/phanpy/commit/${__COMMIT_HASH__}`} target="_blank" rel="noopener" > <RelativeTime datetime={new Date(__BUILD_TIME__)} /> </a> ) </span> )
#: src/pages/settings.jsx:912
msgid "<0>Version:</0> <1/> {0}"
msgstr ""

#: src/pages/settings.jsx:927
msgid "Version string copied"
msgstr ""

#: src/pages/settings.jsx:930
msgid "Unable to copy version string"
msgstr ""

#. Preview of one character, in largest size
#. Preview of one character, in smallest size
#: src/pages/settings.jsx:1074
#: src/pages/settings.jsx:1098
msgid "A"
msgstr ""

#: src/pages/settings.jsx:1248
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1253
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1260
msgid "Push Notifications (beta)"
msgstr ""

#: src/pages/settings.jsx:1282
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#. placeholder {0}: [ { value: 'all', label: t`anyone`, }, { value: 'followed', label: t`people I follow`, }, { value: 'follower', label: t`followers`, }, ].map((type) => ( <option value={type.value}>{type.label}</option> ))
#: src/pages/settings.jsx:1291
msgid "Allow from <0>{0}</0>"
msgstr ""

#: src/pages/settings.jsx:1300
msgid "anyone"
msgstr ""

#: src/pages/settings.jsx:1304
msgid "people I follow"
msgstr ""

#: src/pages/settings.jsx:1308
msgid "followers"
msgstr ""

#: src/pages/settings.jsx:1341
msgid "Follows"
msgstr ""

#: src/pages/settings.jsx:1349
msgid "Polls"
msgstr ""

#: src/pages/settings.jsx:1353
msgid "Post edits"
msgstr ""

#: src/pages/settings.jsx:1374
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1390
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr ""

#: src/pages/status.jsx:156
msgid "Unable to load post."
msgstr "Unable to load post."

#: src/pages/status.jsx:800
#: src/pages/status.jsx:1498
msgctxt "single post"
msgid "Post"
msgstr "Post"

#: src/pages/status.jsx:1097
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr ""

#: src/pages/status.jsx:1117
msgid "This post is from another server (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "This post is from another server (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."

#: src/pages/status.jsx:1152
msgid "Switch to my server to enable interactions"
msgstr "Switch to my server to enable interactions"

#: src/pages/status.jsx:1261
msgid "Unable to load replies."
msgstr ""

#: src/pages/status.jsx:1320
msgid "{months, plural, one {# month later} other {# months later}}"
msgstr "{months, plural, one {# month later} other {# months later}}"

#: src/pages/status.jsx:1326
msgid "{years, plural, one {# year later} other {# years later}}"
msgstr "{years, plural, one {# year later} other {# years later}}"

#: src/pages/status.jsx:1458
msgid "Back"
msgstr ""

#: src/pages/status.jsx:1489
msgid "Go to main post"
msgstr ""

#. placeholder {0}: ancestors.length
#: src/pages/status.jsx:1512
msgid "{0} posts above ‒ Go to top"
msgstr ""

#: src/pages/status.jsx:1561
#: src/pages/status.jsx:1624
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1625
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1643
msgid "Show all sensitive content"
msgstr ""

#: src/pages/status.jsx:1657
msgid "Unable to switch"
msgstr ""

#. placeholder {0}: punycode.toUnicode( postInstance, )
#: src/pages/status.jsx:1664
msgid "Switch to post's server ({0})"
msgstr "Switch to post's server ({0})"

#: src/pages/status.jsx:1667
msgid "Switch to post's server"
msgstr "Switch to post's server"

#: src/pages/status.jsx:1680
msgid "View Edit History Snapshots"
msgstr "View Edit History Snapshots"

#: src/pages/status.jsx:1737
msgid "Unable to load post"
msgstr ""

#. placeholder {0}: replies.length
#. placeholder {1}: shortenNumber(replies.length)
#: src/pages/status.jsx:1876
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr ""

#. placeholder {0}: shortenNumber(totalComments)
#: src/pages/status.jsx:1894
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr ""

#: src/pages/status.jsx:1916
msgid "View post with its replies"
msgstr ""

#: src/pages/trending.jsx:77
msgid "Trending ({instance})"
msgstr "Trending ({instance})"

#: src/pages/trending.jsx:235
msgid "Trending News"
msgstr ""

#. By [Author]
#. placeholder {0}: author ? ( <NameText account={author} showAvatar /> ) : authorUrl ? ( <a href={authorUrl} target="_blank" rel="noopener" > {authorName} </a> ) : ( authorName )
#: src/pages/trending.jsx:350
msgid "By {0}"
msgstr "By {0}"

#: src/pages/trending.jsx:411
msgid "Back to showing trending posts"
msgstr ""

#. placeholder {0}: currentLink .replace(/^https?:\/\/(www\.)?/i, '') .replace(/\/$/, '')
#: src/pages/trending.jsx:416
msgid "Showing posts mentioning <0>{0}</0>"
msgstr ""

#: src/pages/trending.jsx:428
msgid "Trending posts"
msgstr ""

#: src/pages/trending.jsx:451
msgid "No trending posts."
msgstr ""

#: src/pages/welcome.jsx:52
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:63
msgid "Log in with Mastodon"
msgstr ""

#: src/pages/welcome.jsx:69
msgid "Sign up"
msgstr ""

#: src/pages/welcome.jsx:76
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:96
msgid "Screenshot of Phanpy home timeline on mobile device"
msgstr "Screenshot of Phanpy home timeline on mobile device"

#: src/pages/welcome.jsx:113
msgid "Screenshot of Phanpy home timeline on tablet device"
msgstr "Screenshot of Phanpy home timeline on tablet device"

#: src/pages/welcome.jsx:127
msgid "Screenshot of Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:134
msgid "Boosts Carousel"
msgstr ""

#: src/pages/welcome.jsx:137
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr ""

#: src/pages/welcome.jsx:147
msgid "Screenshot of Catch-up"
msgstr "Screenshot of Catch-up"

#: src/pages/welcome.jsx:157
msgid "A separate timeline for followings. Email-inspired interface to sort and filter posts."
msgstr "A separate timeline for followings. Email-inspired interface to sort and filter posts."

#: src/pages/welcome.jsx:167
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:174
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:177
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr ""

#: src/pages/welcome.jsx:186
msgid "Screenshot of multi-column UI"
msgstr ""

#: src/pages/welcome.jsx:193
msgid "Single or multi-column"
msgstr ""

#: src/pages/welcome.jsx:196
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr ""

#: src/pages/welcome.jsx:206
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:213
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:216
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/pages/welcome.jsx:231
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr ""

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""
